var items = {
  "block.minecraft.acacia_button": "Boton de acasia",
  "block.minecraft.acacia_door": "Porta de acasia",
  "block.minecraft.acacia_fence": "Ringhiera de acasia",
  "block.minecraft.acacia_fence_gate": "Sarajo de acasia",
  "block.minecraft.acacia_hanging_sign": "Cartel de acasia picà",
  "block.minecraft.acacia_leaves": "Foje de acasia",
  "block.minecraft.acacia_log": "Fusto de acasia",
  "block.minecraft.acacia_planks": "Ase de acasia",
  "block.minecraft.acacia_pressure_plate": "Pedana a presion de acasia",
  "block.minecraft.acacia_sapling": "Albareło de acasia",
  "block.minecraft.acacia_shelf": "Scansìa de Acacia",
  "block.minecraft.acacia_sign": "Cartel de acasia",
  "block.minecraft.acacia_slab": "Łiston de acasia",
  "block.minecraft.acacia_stairs": "Scałe de acasia",
  "block.minecraft.acacia_trapdoor": "Rebalta de acasia",
  "block.minecraft.acacia_wall_hanging_sign": "Cartel de acasia picà a parede",
  "block.minecraft.acacia_wall_sign": "Cartel de acasia a parede",
  "block.minecraft.acacia_wood": "Łenjo de acasia",
  "block.minecraft.activator_rail": "Roara de ativasion",
  "block.minecraft.air": "Aria",
  "block.minecraft.allium": "Fior de ajo",
  "block.minecraft.amethyst_block": "Bloco de ametista",
  "block.minecraft.amethyst_cluster": "Grumo de Ametista",
  "block.minecraft.ancient_debris": "Ruinassi Antighi",
  "block.minecraft.andesite": "Andezite",
  "block.minecraft.andesite_slab": "Łiston de andezite",
  "block.minecraft.andesite_stairs": "Scałe de andezite",
  "block.minecraft.andesite_wall": "Mureta de andezite",
  "block.minecraft.anvil": "Ancùzene",
  "block.minecraft.attached_melon_stem": "Pianta de inguria maura",
  "block.minecraft.attached_pumpkin_stem": "Pianta de suca maura",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Foje de azalea",
  "block.minecraft.azure_bluet": "Fiori de canpo",
  "block.minecraft.bamboo": "Canavera",
  "block.minecraft.bamboo_block": "Bloco de canavera",
  "block.minecraft.bamboo_button": "Botón de canavera",
  "block.minecraft.bamboo_door": "Porta de canavera",
  "block.minecraft.bamboo_fence": "Serajo de canavera",
  "block.minecraft.bamboo_fence_gate": "Cancełeto de canavera",
  "block.minecraft.bamboo_hanging_sign": "Cartel de canavera picà",
  "block.minecraft.bamboo_mosaic": "Canavera spighetà",
  "block.minecraft.bamboo_mosaic_slab": "Łiston de canavera spighetà",
  "block.minecraft.bamboo_mosaic_stairs": "Scałe de canavera spighetà",
  "block.minecraft.bamboo_planks": "Asse de canavera",
  "block.minecraft.bamboo_pressure_plate": "Pedana a pression de canavera",
  "block.minecraft.bamboo_sapling": "Buto de canavera",
  "block.minecraft.bamboo_shelf": "Scansìa de Canavera",
  "block.minecraft.bamboo_sign": "Cartel de canavera",
  "block.minecraft.bamboo_slab": "Łiston de canavera",
  "block.minecraft.bamboo_stairs": "Scałe de canavera",
  "block.minecraft.bamboo_trapdoor": "Botoa de canavera",
  "block.minecraft.bamboo_wall_hanging_sign": "Cartel de canavera picà a parede",
  "block.minecraft.bamboo_wall_sign": "Cartel de canavera a parede",
  "block.minecraft.banner.base.black": "Canpo negro",
  "block.minecraft.banner.base.blue": "Canpo blé",
  "block.minecraft.banner.base.brown": "Canpo maron",
  "block.minecraft.banner.base.cyan": "Canpo çian",
  "block.minecraft.banner.base.gray": "Canpo griso",
  "block.minecraft.banner.base.green": "Canpo verdo",
  "block.minecraft.banner.base.light_blue": "Canpo çeleste",
  "block.minecraft.banner.base.light_gray": "Canpo griso ciaro",
  "block.minecraft.banner.base.lime": "Canpo lime",
  "block.minecraft.banner.base.magenta": "Canpo magenta",
  "block.minecraft.banner.base.orange": "Canpo naransa",
  "block.minecraft.banner.base.pink": "Canpo rosa",
  "block.minecraft.banner.base.purple": "Canpo viola",
  "block.minecraft.banner.base.red": "Canpo rosso",
  "block.minecraft.banner.base.white": "Canpo bianco",
  "block.minecraft.banner.base.yellow": "Canpo zalo",
  "block.minecraft.banner.border.black": "Bordura de negro",
  "block.minecraft.banner.border.blue": "Bordura de blè",
  "block.minecraft.banner.border.brown": "Bordura de maron",
  "block.minecraft.banner.border.cyan": "Bordura de sian",
  "block.minecraft.banner.border.gray": "Bordura de grizo",
  "block.minecraft.banner.border.green": "Bordura de verdo",
  "block.minecraft.banner.border.light_blue": "Bordura de sełeste",
  "block.minecraft.banner.border.light_gray": "Bordura de grizo ciaro",
  "block.minecraft.banner.border.lime": "Bordura de lime",
  "block.minecraft.banner.border.magenta": "Bordura de mazenta",
  "block.minecraft.banner.border.orange": "Bordura de naransa",
  "block.minecraft.banner.border.pink": "Bordura de roza",
  "block.minecraft.banner.border.purple": "Bordura de vioła",
  "block.minecraft.banner.border.red": "Bordure de roso",
  "block.minecraft.banner.border.white": "Bordura de bianco",
  "block.minecraft.banner.border.yellow": "Bordura de zało",
  "block.minecraft.banner.bricks.black": "Canpo negro de cuarełi",
  "block.minecraft.banner.bricks.blue": "Canpo blè de cuarełi",
  "block.minecraft.banner.bricks.brown": "Canpo maron de cuarełi",
  "block.minecraft.banner.bricks.cyan": "Canpo sian de cuarełi",
  "block.minecraft.banner.bricks.gray": "Canpo grizo de cuarełi",
  "block.minecraft.banner.bricks.green": "Canpo verdo de cuarełi",
  "block.minecraft.banner.bricks.light_blue": "Canpo sełeste de cuarełi",
  "block.minecraft.banner.bricks.light_gray": "Canpo grizo ciaro de cuarełi",
  "block.minecraft.banner.bricks.lime": "Canpo lime de cuarełi",
  "block.minecraft.banner.bricks.magenta": "Canpo mazenta de cuarełi",
  "block.minecraft.banner.bricks.orange": "Canpo naransa de cuarełi",
  "block.minecraft.banner.bricks.pink": "Canpo roza de cuarełi",
  "block.minecraft.banner.bricks.purple": "Canpo vioła de cuarełi",
  "block.minecraft.banner.bricks.red": "Canpo roso de cuarełi",
  "block.minecraft.banner.bricks.white": "Canpo bianco de cuarełi",
  "block.minecraft.banner.bricks.yellow": "Canpo zało de cuarełi",
  "block.minecraft.banner.circle.black": "Serciołeto negro",
  "block.minecraft.banner.circle.blue": "Serciołeto blè",
  "block.minecraft.banner.circle.brown": "Serciołeto maron",
  "block.minecraft.banner.circle.cyan": "Serciołeto sian",
  "block.minecraft.banner.circle.gray": "Serciołeto grizo",
  "block.minecraft.banner.circle.green": "Serciołeto verdo",
  "block.minecraft.banner.circle.light_blue": "Serciołeto sełeste",
  "block.minecraft.banner.circle.light_gray": "Serciołeto grizo ciaro",
  "block.minecraft.banner.circle.lime": "Serciołeto lime",
  "block.minecraft.banner.circle.magenta": "Serciołeto mazenta",
  "block.minecraft.banner.circle.orange": "Serciołeto naransa",
  "block.minecraft.banner.circle.pink": "Serciołeto roza",
  "block.minecraft.banner.circle.purple": "Serciołeto vioła",
  "block.minecraft.banner.circle.red": "Serciołeto roso",
  "block.minecraft.banner.circle.white": "Serciołeto bianco",
  "block.minecraft.banner.circle.yellow": "Serciołeto zało",
  "block.minecraft.banner.creeper.black": "Stanpo de creeper negro",
  "block.minecraft.banner.creeper.blue": "Stanpo de creeper blè",
  "block.minecraft.banner.creeper.brown": "Stanpo de creeper maron",
  "block.minecraft.banner.creeper.cyan": "Stanpo de creeper sian",
  "block.minecraft.banner.creeper.gray": "Stanpo de creeper grizo",
  "block.minecraft.banner.creeper.green": "Stanpo de creeper verdo",
  "block.minecraft.banner.creeper.light_blue": "Stanpo de creeper sełeste",
  "block.minecraft.banner.creeper.light_gray": "Stanpo de creeper grizo ciaro",
  "block.minecraft.banner.creeper.lime": "Stanpo de creeper lime",
  "block.minecraft.banner.creeper.magenta": "Stanpo de creeper mazenta",
  "block.minecraft.banner.creeper.orange": "Stanpo de creeper naransa",
  "block.minecraft.banner.creeper.pink": "Stanpo de creeper roza",
  "block.minecraft.banner.creeper.purple": "Stanpo de creeper vioła",
  "block.minecraft.banner.creeper.red": "Stanpo de creeper roso",
  "block.minecraft.banner.creeper.white": "Stanpo de creeper bianco",
  "block.minecraft.banner.creeper.yellow": "Stanpo de creeper zało",
  "block.minecraft.banner.cross.black": "Decusa negra",
  "block.minecraft.banner.cross.blue": "Decusa blè",
  "block.minecraft.banner.cross.brown": "Decusa maron",
  "block.minecraft.banner.cross.cyan": "Decusa sian",
  "block.minecraft.banner.cross.gray": "Decusa griza",
  "block.minecraft.banner.cross.green": "Decusa verda",
  "block.minecraft.banner.cross.light_blue": "Decusa sełeste",
  "block.minecraft.banner.cross.light_gray": "Decusa griza ciara",
  "block.minecraft.banner.cross.lime": "Decusa lime",
  "block.minecraft.banner.cross.magenta": "Decusa mazenta",
  "block.minecraft.banner.cross.orange": "Decusa naransa",
  "block.minecraft.banner.cross.pink": "Decusa roza",
  "block.minecraft.banner.cross.purple": "Decusa vioła",
  "block.minecraft.banner.cross.red": "Decusa rosa",
  "block.minecraft.banner.cross.white": "Decusa bianca",
  "block.minecraft.banner.cross.yellow": "Decusa zała",
  "block.minecraft.banner.curly_border.black": "Bordura dentada de nero",
  "block.minecraft.banner.curly_border.blue": "Bordura dentada de blè",
  "block.minecraft.banner.curly_border.brown": "Bordura dentada de maron",
  "block.minecraft.banner.curly_border.cyan": "Bordura dentada de sian",
  "block.minecraft.banner.curly_border.gray": "Bordura dentada de grizo",
  "block.minecraft.banner.curly_border.green": "Bordura dentada de verdo",
  "block.minecraft.banner.curly_border.light_blue": "Bordura dentada de sełeste",
  "block.minecraft.banner.curly_border.light_gray": "Bordura dentada de grizo ciaro",
  "block.minecraft.banner.curly_border.lime": "Bordura dentada de lime",
  "block.minecraft.banner.curly_border.magenta": "Bordura dentada de mazenta",
  "block.minecraft.banner.curly_border.orange": "Bordura dentada de naransa",
  "block.minecraft.banner.curly_border.pink": "Bordura dentada de roza",
  "block.minecraft.banner.curly_border.purple": "Bordura dentada de vioła",
  "block.minecraft.banner.curly_border.red": "Bordura dentada de roso",
  "block.minecraft.banner.curly_border.white": "Bordura dentada de bianco",
  "block.minecraft.banner.curly_border.yellow": "Bordura dentada de zało",
  "block.minecraft.banner.diagonal_left.black": "Canton dx in sima de negro",
  "block.minecraft.banner.diagonal_left.blue": "Canton dx in sima de blè",
  "block.minecraft.banner.diagonal_left.brown": "Canton dx in sima de maron",
  "block.minecraft.banner.diagonal_left.cyan": "Canton dx in sima de sian",
  "block.minecraft.banner.diagonal_left.gray": "Canton dx in sima de grizo",
  "block.minecraft.banner.diagonal_left.green": "Canton dx in sima de verdo",
  "block.minecraft.banner.diagonal_left.light_blue": "Canton dx in sima de sełeste",
  "block.minecraft.banner.diagonal_left.light_gray": "Canton dx in sima de grizo ciaro",
  "block.minecraft.banner.diagonal_left.lime": "Canton dx in sima de lime",
  "block.minecraft.banner.diagonal_left.magenta": "Canton dx in sima de mazenta",
  "block.minecraft.banner.diagonal_left.orange": "Canton dx in sima de naransa",
  "block.minecraft.banner.diagonal_left.pink": "Canton dx in sima de roza",
  "block.minecraft.banner.diagonal_left.purple": "Canton dx in sima de vioła",
  "block.minecraft.banner.diagonal_left.red": "Canton dx in sima de roso",
  "block.minecraft.banner.diagonal_left.white": "Canton dx in sima de bianco",
  "block.minecraft.banner.diagonal_left.yellow": "Canton dx in sima de zało",
  "block.minecraft.banner.diagonal_right.black": "Canton sx in sima de negro",
  "block.minecraft.banner.diagonal_right.blue": "Canton sx in sima de blè",
  "block.minecraft.banner.diagonal_right.brown": "Canton sx in sima de maron",
  "block.minecraft.banner.diagonal_right.cyan": "Canton sx in sima de sian",
  "block.minecraft.banner.diagonal_right.gray": "Canton sx in sima de grizo",
  "block.minecraft.banner.diagonal_right.green": "Canton sx in sima de verdo",
  "block.minecraft.banner.diagonal_right.light_blue": "Canton sx in sima de sełeste",
  "block.minecraft.banner.diagonal_right.light_gray": "Canton sx in sima de grizo ciaro",
  "block.minecraft.banner.diagonal_right.lime": "Canton sx in sima de lime",
  "block.minecraft.banner.diagonal_right.magenta": "Canton sx in sima de mazenta",
  "block.minecraft.banner.diagonal_right.orange": "Canton sx in sima de naransa",
  "block.minecraft.banner.diagonal_right.pink": "Canton sx in sima de roza",
  "block.minecraft.banner.diagonal_right.purple": "Canton sx in sima de vioła",
  "block.minecraft.banner.diagonal_right.red": "Canton sx in sima de roso",
  "block.minecraft.banner.diagonal_right.white": "Canton sx in sima de bianco",
  "block.minecraft.banner.diagonal_right.yellow": "Canton sx in sima de zało",
  "block.minecraft.banner.diagonal_up_left.black": "Canton dx in baso de negro",
  "block.minecraft.banner.diagonal_up_left.blue": "Canton dx in baso de blè",
  "block.minecraft.banner.diagonal_up_left.brown": "Canton dx in baso de maron",
  "block.minecraft.banner.diagonal_up_left.cyan": "Canton dx in baso de sian",
  "block.minecraft.banner.diagonal_up_left.gray": "Canton dx in baso de grizo",
  "block.minecraft.banner.diagonal_up_left.green": "Canton dx in baso de verdo",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Canton dx in baso de sełeste",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Canton dx in baso de grizo ciaro",
  "block.minecraft.banner.diagonal_up_left.lime": "Canton dx in baso de lime",
  "block.minecraft.banner.diagonal_up_left.magenta": "Canton dx in baso de mazenta",
  "block.minecraft.banner.diagonal_up_left.orange": "Canton dx in baso de naransa",
  "block.minecraft.banner.diagonal_up_left.pink": "Canton dx in baso de roza",
  "block.minecraft.banner.diagonal_up_left.purple": "Canton dx in baso de vioła",
  "block.minecraft.banner.diagonal_up_left.red": "Canton dx in baso de roso",
  "block.minecraft.banner.diagonal_up_left.white": "Canton dx in baso de bianco",
  "block.minecraft.banner.diagonal_up_left.yellow": "Canton dx in baso de zało",
  "block.minecraft.banner.diagonal_up_right.black": "Canton sx in baso de negro",
  "block.minecraft.banner.diagonal_up_right.blue": "Canton sx in baso de blè",
  "block.minecraft.banner.diagonal_up_right.brown": "Canton sx in baso de maron",
  "block.minecraft.banner.diagonal_up_right.cyan": "Canton sx in baso de sian",
  "block.minecraft.banner.diagonal_up_right.gray": "Canton sx in baso de grizo",
  "block.minecraft.banner.diagonal_up_right.green": "Canton sx in baso de verdo",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Canton sx in baso de sełeste",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Canton sx in baso de grizo ciaro",
  "block.minecraft.banner.diagonal_up_right.lime": "Canton sx in baso de lime",
  "block.minecraft.banner.diagonal_up_right.magenta": "Canton sx in baso de mazenta",
  "block.minecraft.banner.diagonal_up_right.orange": "Canton sx in baso de naransa",
  "block.minecraft.banner.diagonal_up_right.pink": "Canton sx in baso de roza",
  "block.minecraft.banner.diagonal_up_right.purple": "Canton sx in baso de vioła",
  "block.minecraft.banner.diagonal_up_right.red": "Canton sx in baso de roso",
  "block.minecraft.banner.diagonal_up_right.white": "Canton sx in baso de bianco",
  "block.minecraft.banner.diagonal_up_right.yellow": "Canton sx in baso de zało",
  "block.minecraft.banner.flow.black": "Fluso negro",
  "block.minecraft.banner.flow.blue": "Fluso blu",
  "block.minecraft.banner.flow.brown": "Fluso Maron",
  "block.minecraft.banner.flow.cyan": "Fluso Sian",
  "block.minecraft.banner.flow.gray": "Fluso Grizo",
  "block.minecraft.banner.flow.green": "Fluso Verdo",
  "block.minecraft.banner.flow.light_blue": "Fluso Sełeste",
  "block.minecraft.banner.flow.light_gray": "Fluso Grizo Ciaro",
  "block.minecraft.banner.flow.lime": "Fluso Lime",
  "block.minecraft.banner.flow.magenta": "Fluso Mazenta",
  "block.minecraft.banner.flow.orange": "Fluso Naransa",
  "block.minecraft.banner.flow.pink": "Fluso Roza",
  "block.minecraft.banner.flow.purple": "Fluso Vioła",
  "block.minecraft.banner.flow.red": "Fluso Roso",
  "block.minecraft.banner.flow.white": "Fluso Bianco",
  "block.minecraft.banner.flow.yellow": "Fluso Zało",
  "block.minecraft.banner.flower.black": "Fior negro",
  "block.minecraft.banner.flower.blue": "Fior blè",
  "block.minecraft.banner.flower.brown": "Fior maron",
  "block.minecraft.banner.flower.cyan": "Fior sian",
  "block.minecraft.banner.flower.gray": "Fior grizo",
  "block.minecraft.banner.flower.green": "Fior verdo",
  "block.minecraft.banner.flower.light_blue": "Fior sełeste",
  "block.minecraft.banner.flower.light_gray": "Fior grizo ciaro",
  "block.minecraft.banner.flower.lime": "Fior lime",
  "block.minecraft.banner.flower.magenta": "Fior mazenta",
  "block.minecraft.banner.flower.orange": "Fior naransa",
  "block.minecraft.banner.flower.pink": "Fior roza",
  "block.minecraft.banner.flower.purple": "Fior vioła",
  "block.minecraft.banner.flower.red": "Fior roso",
  "block.minecraft.banner.flower.white": "Fior bianco",
  "block.minecraft.banner.flower.yellow": "Fior zało",
  "block.minecraft.banner.globe.black": "Globo negro",
  "block.minecraft.banner.globe.blue": "Globo blè",
  "block.minecraft.banner.globe.brown": "Globo maron",
  "block.minecraft.banner.globe.cyan": "Globo sian",
  "block.minecraft.banner.globe.gray": "Globo grizo",
  "block.minecraft.banner.globe.green": "Globo verdo",
  "block.minecraft.banner.globe.light_blue": "Globo sełeste",
  "block.minecraft.banner.globe.light_gray": "Globo grizo ciaro",
  "block.minecraft.banner.globe.lime": "Globo lime",
  "block.minecraft.banner.globe.magenta": "Globo mazenta",
  "block.minecraft.banner.globe.orange": "Globo naransa",
  "block.minecraft.banner.globe.pink": "Globo roza",
  "block.minecraft.banner.globe.purple": "Globo vioła",
  "block.minecraft.banner.globe.red": "Globo roso",
  "block.minecraft.banner.globe.white": "Globo bianco",
  "block.minecraft.banner.globe.yellow": "Globo zało",
  "block.minecraft.banner.gradient.black": "Desfumà de negro",
  "block.minecraft.banner.gradient.blue": "Desfumà de blè",
  "block.minecraft.banner.gradient.brown": "Desfumà de maron",
  "block.minecraft.banner.gradient.cyan": "Desfumà de sian",
  "block.minecraft.banner.gradient.gray": "Desfumà de grizo",
  "block.minecraft.banner.gradient.green": "Desfumà de verdo",
  "block.minecraft.banner.gradient.light_blue": "Desfumà de sełeste",
  "block.minecraft.banner.gradient.light_gray": "Desfumà de grizo ciaro",
  "block.minecraft.banner.gradient.lime": "Desfumà de lime",
  "block.minecraft.banner.gradient.magenta": "Desfumà de mazenta",
  "block.minecraft.banner.gradient.orange": "Desfumà de naransa",
  "block.minecraft.banner.gradient.pink": "Desfumà de roza",
  "block.minecraft.banner.gradient.purple": "Desfumà de vioła",
  "block.minecraft.banner.gradient.red": "Desfumà de roso",
  "block.minecraft.banner.gradient.white": "Desfumà de bianco",
  "block.minecraft.banner.gradient.yellow": "Desfumà de zało",
  "block.minecraft.banner.gradient_up.black": "Piè sfumà de negro",
  "block.minecraft.banner.gradient_up.blue": "Piè sfumà de blè",
  "block.minecraft.banner.gradient_up.brown": "Piè sfumà de maron",
  "block.minecraft.banner.gradient_up.cyan": "Piè sfumà de sian",
  "block.minecraft.banner.gradient_up.gray": "Piè sfumà de grizo",
  "block.minecraft.banner.gradient_up.green": "Piè sfumà de verdo",
  "block.minecraft.banner.gradient_up.light_blue": "Piè sfumà de sełeste",
  "block.minecraft.banner.gradient_up.light_gray": "Piè sfumà de grizo ciaro",
  "block.minecraft.banner.gradient_up.lime": "Piè sfumà de lime",
  "block.minecraft.banner.gradient_up.magenta": "Piè sfumà de mazenta",
  "block.minecraft.banner.gradient_up.orange": "Piè sfumà de naransa",
  "block.minecraft.banner.gradient_up.pink": "Piè sfumà de roza",
  "block.minecraft.banner.gradient_up.purple": "Piè sfumà de vioła",
  "block.minecraft.banner.gradient_up.red": "Piè sfumà de roso",
  "block.minecraft.banner.gradient_up.white": "Piè sfumà de bianco",
  "block.minecraft.banner.gradient_up.yellow": "Piè sfumà de zało",
  "block.minecraft.banner.guster.black": "Sboàda Negra",
  "block.minecraft.banner.guster.blue": "Sboàda Blu",
  "block.minecraft.banner.guster.brown": "Sboàda Maron",
  "block.minecraft.banner.guster.cyan": "Sboàda Cian",
  "block.minecraft.banner.guster.gray": "Sboàda Griza",
  "block.minecraft.banner.guster.green": "Sboàda Verda",
  "block.minecraft.banner.guster.light_blue": "Sboàda cełeste",
  "block.minecraft.banner.guster.light_gray": "Sboàda griza ciara",
  "block.minecraft.banner.guster.lime": "Sboàda Lime",
  "block.minecraft.banner.guster.magenta": "Sboàda mazenta",
  "block.minecraft.banner.guster.orange": "Sboàda Naransa",
  "block.minecraft.banner.guster.pink": "Sboàda Rosa",
  "block.minecraft.banner.guster.purple": "Sboàda Viola",
  "block.minecraft.banner.guster.red": "Sboàda Rossa",
  "block.minecraft.banner.guster.white": "Sboàda Bianca",
  "block.minecraft.banner.guster.yellow": "Sboàda Zala",
  "block.minecraft.banner.half_horizontal.black": "Negro de sora",
  "block.minecraft.banner.half_horizontal.blue": "Blè de sora",
  "block.minecraft.banner.half_horizontal.brown": "Maron de sora",
  "block.minecraft.banner.half_horizontal.cyan": "Sian de sora",
  "block.minecraft.banner.half_horizontal.gray": "Grizo de sora",
  "block.minecraft.banner.half_horizontal.green": "Verdo de sora",
  "block.minecraft.banner.half_horizontal.light_blue": "Sełeste de sora",
  "block.minecraft.banner.half_horizontal.light_gray": "Grizo ciaro de sora",
  "block.minecraft.banner.half_horizontal.lime": "Lime de sora",
  "block.minecraft.banner.half_horizontal.magenta": "Mazenta de sora",
  "block.minecraft.banner.half_horizontal.orange": "Naransa de sora",
  "block.minecraft.banner.half_horizontal.pink": "Roza de sora",
  "block.minecraft.banner.half_horizontal.purple": "Vioła de sora",
  "block.minecraft.banner.half_horizontal.red": "Roso de sora",
  "block.minecraft.banner.half_horizontal.white": "Bianco de sora",
  "block.minecraft.banner.half_horizontal.yellow": "Zało de sora",
  "block.minecraft.banner.half_horizontal_bottom.black": "Negro de soto",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blè de soto",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Maron de soto",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Sian de soto",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grizo de soto",
  "block.minecraft.banner.half_horizontal_bottom.green": "Verdo de soto",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Sełeste de soto",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Grizo ciaro de soto",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Lime de soto",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Mazenta de soto",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Naransa de soto",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roza de soto",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Vioła de soto",
  "block.minecraft.banner.half_horizontal_bottom.red": "Roso de soto",
  "block.minecraft.banner.half_horizontal_bottom.white": "Bianco de soto",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Zało de soto",
  "block.minecraft.banner.half_vertical.black": "Partìo a drita de negro",
  "block.minecraft.banner.half_vertical.blue": "Partìo a drita de blè",
  "block.minecraft.banner.half_vertical.brown": "Partìo a drita de maron",
  "block.minecraft.banner.half_vertical.cyan": "Partìo a drita de sian",
  "block.minecraft.banner.half_vertical.gray": "Partìo a drita de grizo",
  "block.minecraft.banner.half_vertical.green": "Partìo a drita de verdo",
  "block.minecraft.banner.half_vertical.light_blue": "Partìo a drita de sełeste",
  "block.minecraft.banner.half_vertical.light_gray": "Partìo a drita de grizo ciaro",
  "block.minecraft.banner.half_vertical.lime": "Partìo a drita de lime",
  "block.minecraft.banner.half_vertical.magenta": "Partìo a drita de mazenta",
  "block.minecraft.banner.half_vertical.orange": "Partìo a drita de naransa",
  "block.minecraft.banner.half_vertical.pink": "Partìo a drita de roza",
  "block.minecraft.banner.half_vertical.purple": "Partìo a drita de vioła",
  "block.minecraft.banner.half_vertical.red": "Partìo a drita de roso",
  "block.minecraft.banner.half_vertical.white": "Partìo a drita de bianco",
  "block.minecraft.banner.half_vertical.yellow": "Partio a drita de zało",
  "block.minecraft.banner.half_vertical_right.black": "Partìo a sanca de negro",
  "block.minecraft.banner.half_vertical_right.blue": "Partìo a sanca de blè",
  "block.minecraft.banner.half_vertical_right.brown": "Partìo a sanca de maron",
  "block.minecraft.banner.half_vertical_right.cyan": "Partìo a sanca de sian",
  "block.minecraft.banner.half_vertical_right.gray": "Partìo a sanca de grizo",
  "block.minecraft.banner.half_vertical_right.green": "Partìo a sanca de verdo",
  "block.minecraft.banner.half_vertical_right.light_blue": "Partìo a sanca de sełeste",
  "block.minecraft.banner.half_vertical_right.light_gray": "Partìo a sanca de grizo ciaro",
  "block.minecraft.banner.half_vertical_right.lime": "Partìo a sanca de lime",
  "block.minecraft.banner.half_vertical_right.magenta": "Partìo a sanca de mazenta",
  "block.minecraft.banner.half_vertical_right.orange": "Partìo a sanca de naransa",
  "block.minecraft.banner.half_vertical_right.pink": "Partìo a sanca de roza",
  "block.minecraft.banner.half_vertical_right.purple": "Partìo a sanca de vioła",
  "block.minecraft.banner.half_vertical_right.red": "Partìo a sanca de roso",
  "block.minecraft.banner.half_vertical_right.white": "Partìo a sanca de bianco",
  "block.minecraft.banner.half_vertical_right.yellow": "Partìo a sanca de zało",
  "block.minecraft.banner.mojang.black": "Logo negro",
  "block.minecraft.banner.mojang.blue": "Logo blè",
  "block.minecraft.banner.mojang.brown": "Logo maron",
  "block.minecraft.banner.mojang.cyan": "Logo sian",
  "block.minecraft.banner.mojang.gray": "Logo grizo",
  "block.minecraft.banner.mojang.green": "Logo verdo",
  "block.minecraft.banner.mojang.light_blue": "Logo sełeste",
  "block.minecraft.banner.mojang.light_gray": "Logo grizo ciaro",
  "block.minecraft.banner.mojang.lime": "Logo lime",
  "block.minecraft.banner.mojang.magenta": "Logo mazenta",
  "block.minecraft.banner.mojang.orange": "Logo naransa",
  "block.minecraft.banner.mojang.pink": "Logo roza",
  "block.minecraft.banner.mojang.purple": "Logo vioła",
  "block.minecraft.banner.mojang.red": "Logo roso",
  "block.minecraft.banner.mojang.white": "Logo bianco",
  "block.minecraft.banner.mojang.yellow": "Logo zało",
  "block.minecraft.banner.piglin.black": "Grugno negro",
  "block.minecraft.banner.piglin.blue": "Grugno blé",
  "block.minecraft.banner.piglin.brown": "Grugno maron",
  "block.minecraft.banner.piglin.cyan": "Grugno çian",
  "block.minecraft.banner.piglin.gray": "Grugno griso",
  "block.minecraft.banner.piglin.green": "Grugno verdo",
  "block.minecraft.banner.piglin.light_blue": "Grugno çeleste",
  "block.minecraft.banner.piglin.light_gray": "Grugno griso ciaro",
  "block.minecraft.banner.piglin.lime": "Grugno lime",
  "block.minecraft.banner.piglin.magenta": "Grugno magenta",
  "block.minecraft.banner.piglin.orange": "Grugno naransa",
  "block.minecraft.banner.piglin.pink": "Grugno rosa",
  "block.minecraft.banner.piglin.purple": "Grugno viola",
  "block.minecraft.banner.piglin.red": "Grugno rosso",
  "block.minecraft.banner.piglin.white": "Grugno bianco",
  "block.minecraft.banner.piglin.yellow": "Grugno zalo",
  "block.minecraft.banner.rhombus.black": "Łozanga negra",
  "block.minecraft.banner.rhombus.blue": "Łozanga blè",
  "block.minecraft.banner.rhombus.brown": "Łozanga maron",
  "block.minecraft.banner.rhombus.cyan": "Łozanga sian",
  "block.minecraft.banner.rhombus.gray": "Łozanga griza",
  "block.minecraft.banner.rhombus.green": "Łozanga verda",
  "block.minecraft.banner.rhombus.light_blue": "Łozanga sełeste",
  "block.minecraft.banner.rhombus.light_gray": "Łozanga griza ciara",
  "block.minecraft.banner.rhombus.lime": "Łozanga lime",
  "block.minecraft.banner.rhombus.magenta": "Łozanga mazenta",
  "block.minecraft.banner.rhombus.orange": "Łozanga naransa",
  "block.minecraft.banner.rhombus.pink": "Łozanga roza",
  "block.minecraft.banner.rhombus.purple": "Łozanga vioła",
  "block.minecraft.banner.rhombus.red": "Łozanga rosa",
  "block.minecraft.banner.rhombus.white": "Łozanga bianca",
  "block.minecraft.banner.rhombus.yellow": "Łozanga zała",
  "block.minecraft.banner.skull.black": "Stanpo de tescio negro",
  "block.minecraft.banner.skull.blue": "Stanpo de tescio blè",
  "block.minecraft.banner.skull.brown": "Stanpo de tescio maron",
  "block.minecraft.banner.skull.cyan": "Stanpo de tescio sian",
  "block.minecraft.banner.skull.gray": "Stanpo de tescio grizo",
  "block.minecraft.banner.skull.green": "Stanpo de tescio verdo",
  "block.minecraft.banner.skull.light_blue": "Stanpo de tescio sełeste",
  "block.minecraft.banner.skull.light_gray": "Stanpo de tescio grizo ciaro",
  "block.minecraft.banner.skull.lime": "Stanpo de tescio lime",
  "block.minecraft.banner.skull.magenta": "Stanpo de tescio mazenta",
  "block.minecraft.banner.skull.orange": "Stanpo de tescio naransa",
  "block.minecraft.banner.skull.pink": "Stanpo de tescio roza",
  "block.minecraft.banner.skull.purple": "Stanpo de tescio vioła",
  "block.minecraft.banner.skull.red": "Stanpo de tescio roso",
  "block.minecraft.banner.skull.white": "Stanpo de tescio bianco",
  "block.minecraft.banner.skull.yellow": "Stanpo de tescio zało",
  "block.minecraft.banner.small_stripes.black": "Pałà de negro",
  "block.minecraft.banner.small_stripes.blue": "Pałà de blè",
  "block.minecraft.banner.small_stripes.brown": "Pałà de maron",
  "block.minecraft.banner.small_stripes.cyan": "Pałà de sian",
  "block.minecraft.banner.small_stripes.gray": "Pałà de grizo",
  "block.minecraft.banner.small_stripes.green": "Pałà de verdo",
  "block.minecraft.banner.small_stripes.light_blue": "Pałà de sełeste",
  "block.minecraft.banner.small_stripes.light_gray": "Pałà de grizo ciaro",
  "block.minecraft.banner.small_stripes.lime": "Pałà de lime",
  "block.minecraft.banner.small_stripes.magenta": "Pałà de mazenta",
  "block.minecraft.banner.small_stripes.orange": "Pałà de naransa",
  "block.minecraft.banner.small_stripes.pink": "Pałà de roza",
  "block.minecraft.banner.small_stripes.purple": "Pałà de vioła",
  "block.minecraft.banner.small_stripes.red": "Pałà de roso",
  "block.minecraft.banner.small_stripes.white": "Pałà de bianco",
  "block.minecraft.banner.small_stripes.yellow": "Pałà de zało",
  "block.minecraft.banner.square_bottom_left.black": "Canton destro de ła ponta de negro",
  "block.minecraft.banner.square_bottom_left.blue": "Canton destro de ła ponta de blè",
  "block.minecraft.banner.square_bottom_left.brown": "Canton destro de ła ponta de maron",
  "block.minecraft.banner.square_bottom_left.cyan": "Canton destro de ła ponta de sian",
  "block.minecraft.banner.square_bottom_left.gray": "Canton destro de ła ponta de grizo",
  "block.minecraft.banner.square_bottom_left.green": "Canton destro de ła ponta de verdo",
  "block.minecraft.banner.square_bottom_left.light_blue": "Canton destro de ła ponta de sełeste",
  "block.minecraft.banner.square_bottom_left.light_gray": "Canton destro de ła ponta de grizo ciaro",
  "block.minecraft.banner.square_bottom_left.lime": "Canton destro de ła ponta de lime",
  "block.minecraft.banner.square_bottom_left.magenta": "Canton destro de ła ponta de mazenta",
  "block.minecraft.banner.square_bottom_left.orange": "Canton destro de ła ponta de naransa",
  "block.minecraft.banner.square_bottom_left.pink": "Canton destro de ła ponta de roza",
  "block.minecraft.banner.square_bottom_left.purple": "Canton destro de ła ponta de vioła",
  "block.minecraft.banner.square_bottom_left.red": "Canton destro de ła ponta de roso",
  "block.minecraft.banner.square_bottom_left.white": "Canton destro de ła ponta de bianco",
  "block.minecraft.banner.square_bottom_left.yellow": "Canton destro de ła ponta de zało",
  "block.minecraft.banner.square_bottom_right.black": "Canton sinistro de ła ponta de negro",
  "block.minecraft.banner.square_bottom_right.blue": "Canton sinistro de ła ponta de blè",
  "block.minecraft.banner.square_bottom_right.brown": "Canton sinistro de ła ponta de maron",
  "block.minecraft.banner.square_bottom_right.cyan": "Canton sinistro de ła ponta de sian",
  "block.minecraft.banner.square_bottom_right.gray": "Canton sinistro de ła ponta de grizo",
  "block.minecraft.banner.square_bottom_right.green": "Canton sinistro de ła ponta de verdo",
  "block.minecraft.banner.square_bottom_right.light_blue": "Canton sinistro de ła ponta de sełeste",
  "block.minecraft.banner.square_bottom_right.light_gray": "Canton sinistro de ła ponta de grizo ciaro",
  "block.minecraft.banner.square_bottom_right.lime": "Canton sinistro de ła ponta de lime",
  "block.minecraft.banner.square_bottom_right.magenta": "Canton sinistro de ła ponta de mazenta",
  "block.minecraft.banner.square_bottom_right.orange": "Canton sinistro de ła ponta de naransa",
  "block.minecraft.banner.square_bottom_right.pink": "Canton sinistro de ła ponta de roza",
  "block.minecraft.banner.square_bottom_right.purple": "Canton sinistro de ła ponta de vioła",
  "block.minecraft.banner.square_bottom_right.red": "Canton sinistro de ła ponta de roso",
  "block.minecraft.banner.square_bottom_right.white": "Canton sinistro de ła ponta de bianco",
  "block.minecraft.banner.square_bottom_right.yellow": "Canton sinistro de ła ponta de zało",
  "block.minecraft.banner.square_top_left.black": "Canton destro in cao de negro",
  "block.minecraft.banner.square_top_left.blue": "Canton destro in cao de blè",
  "block.minecraft.banner.square_top_left.brown": "Canton destro in cao de maron",
  "block.minecraft.banner.square_top_left.cyan": "Canton destro in cao de sian",
  "block.minecraft.banner.square_top_left.gray": "Canton destro in cao de grizo",
  "block.minecraft.banner.square_top_left.green": "Canton destro in cao de verdo",
  "block.minecraft.banner.square_top_left.light_blue": "Canton destro in cao de sełeste",
  "block.minecraft.banner.square_top_left.light_gray": "Canton destro in cao de grizo ciaro",
  "block.minecraft.banner.square_top_left.lime": "Canton destro in cao de lime",
  "block.minecraft.banner.square_top_left.magenta": "Canton destro in cao de mazenta",
  "block.minecraft.banner.square_top_left.orange": "Canton destro in cao de naransa",
  "block.minecraft.banner.square_top_left.pink": "Canton destro in cao de roza",
  "block.minecraft.banner.square_top_left.purple": "Canton destro in cao de vioła",
  "block.minecraft.banner.square_top_left.red": "Canton destro in cao de roso",
  "block.minecraft.banner.square_top_left.white": "Canton destro in cao de bianco",
  "block.minecraft.banner.square_top_left.yellow": "Canton destro in cao de zało",
  "block.minecraft.banner.square_top_right.black": "Canton sinistro in cao de negro",
  "block.minecraft.banner.square_top_right.blue": "Canton sinistro in cao de blè",
  "block.minecraft.banner.square_top_right.brown": "Canton sinistro in cao de maron",
  "block.minecraft.banner.square_top_right.cyan": "Canton sinistro in cao de sian",
  "block.minecraft.banner.square_top_right.gray": "Canton sinistro in cao de grizo",
  "block.minecraft.banner.square_top_right.green": "Canton sinistro in cao de verdo",
  "block.minecraft.banner.square_top_right.light_blue": "Canton sinistro in cao de sełeste",
  "block.minecraft.banner.square_top_right.light_gray": "Canton sinistro in caos de grizo ciaro",
  "block.minecraft.banner.square_top_right.lime": "Canton sinistro in cao de lime",
  "block.minecraft.banner.square_top_right.magenta": "Canton sinistro in cao de mazenta",
  "block.minecraft.banner.square_top_right.orange": "Canton sinistro in cao de naransa",
  "block.minecraft.banner.square_top_right.pink": "Canton sinistro in cao de roza",
  "block.minecraft.banner.square_top_right.purple": "Canton sinistro in cao de vioła",
  "block.minecraft.banner.square_top_right.red": "Canton sinistro in cao de roso",
  "block.minecraft.banner.square_top_right.white": "Canton sinistro in cao de bianco",
  "block.minecraft.banner.square_top_right.yellow": "Canton sinistro in cao de zało",
  "block.minecraft.banner.straight_cross.black": "Croze negra",
  "block.minecraft.banner.straight_cross.blue": "Croze blè",
  "block.minecraft.banner.straight_cross.brown": "Croze maron",
  "block.minecraft.banner.straight_cross.cyan": "Croze sian",
  "block.minecraft.banner.straight_cross.gray": "Croze griza",
  "block.minecraft.banner.straight_cross.green": "Croze verda",
  "block.minecraft.banner.straight_cross.light_blue": "Croze cełeste",
  "block.minecraft.banner.straight_cross.light_gray": "Croze griza ciara",
  "block.minecraft.banner.straight_cross.lime": "Croze lime",
  "block.minecraft.banner.straight_cross.magenta": "Croze mazenta",
  "block.minecraft.banner.straight_cross.orange": "Croze naransa",
  "block.minecraft.banner.straight_cross.pink": "Croze roza",
  "block.minecraft.banner.straight_cross.purple": "Croze vioła",
  "block.minecraft.banner.straight_cross.red": "Croze rosa",
  "block.minecraft.banner.straight_cross.white": "Croze bianca",
  "block.minecraft.banner.straight_cross.yellow": "Croze zała",
  "block.minecraft.banner.stripe_bottom.black": "Baze negra",
  "block.minecraft.banner.stripe_bottom.blue": "Baze blè",
  "block.minecraft.banner.stripe_bottom.brown": "Baze maron",
  "block.minecraft.banner.stripe_bottom.cyan": "Baze sian",
  "block.minecraft.banner.stripe_bottom.gray": "Baze griza",
  "block.minecraft.banner.stripe_bottom.green": "Baze verda",
  "block.minecraft.banner.stripe_bottom.light_blue": "Baze sełeste",
  "block.minecraft.banner.stripe_bottom.light_gray": "Baze griza ciara",
  "block.minecraft.banner.stripe_bottom.lime": "Baze lime",
  "block.minecraft.banner.stripe_bottom.magenta": "Baze mazenta",
  "block.minecraft.banner.stripe_bottom.orange": "Baze naransa",
  "block.minecraft.banner.stripe_bottom.pink": "Baze roza",
  "block.minecraft.banner.stripe_bottom.purple": "Baze vioła",
  "block.minecraft.banner.stripe_bottom.red": "Baze rosa",
  "block.minecraft.banner.stripe_bottom.white": "Baze bianca",
  "block.minecraft.banner.stripe_bottom.yellow": "Baze zała",
  "block.minecraft.banner.stripe_center.black": "Pèrtega negra",
  "block.minecraft.banner.stripe_center.blue": "Pèrtega blè",
  "block.minecraft.banner.stripe_center.brown": "Pèrtega maron",
  "block.minecraft.banner.stripe_center.cyan": "Pèrtega sian",
  "block.minecraft.banner.stripe_center.gray": "Pèrtega griza",
  "block.minecraft.banner.stripe_center.green": "Pèrtega verda",
  "block.minecraft.banner.stripe_center.light_blue": "Pèrtega sełeste",
  "block.minecraft.banner.stripe_center.light_gray": "Pèrtega griza ciara",
  "block.minecraft.banner.stripe_center.lime": "Pèrtega lime",
  "block.minecraft.banner.stripe_center.magenta": "Pèrtega mazenta",
  "block.minecraft.banner.stripe_center.orange": "Pèrtega naransa",
  "block.minecraft.banner.stripe_center.pink": "Pèrtega roza",
  "block.minecraft.banner.stripe_center.purple": "Pèrtega vioła",
  "block.minecraft.banner.stripe_center.red": "Pèrtega rosa",
  "block.minecraft.banner.stripe_center.white": "Pèrtega bianca",
  "block.minecraft.banner.stripe_center.yellow": "Pèrtega zała",
  "block.minecraft.banner.stripe_downleft.black": "Banda negra sinistra",
  "block.minecraft.banner.stripe_downleft.blue": "Banda blè sinistra",
  "block.minecraft.banner.stripe_downleft.brown": "Banda maron sinistra",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda sian sinistra",
  "block.minecraft.banner.stripe_downleft.gray": "Banda griza sinistra",
  "block.minecraft.banner.stripe_downleft.green": "Banda verda sinistra",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda sełeste sinistra",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda griza ciara sinistra",
  "block.minecraft.banner.stripe_downleft.lime": "Banda lime sinsitra",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda mazenta sinistra",
  "block.minecraft.banner.stripe_downleft.orange": "Banda naransa sinistra",
  "block.minecraft.banner.stripe_downleft.pink": "Banda roza sinistra",
  "block.minecraft.banner.stripe_downleft.purple": "Banda vioła sinistra",
  "block.minecraft.banner.stripe_downleft.red": "Banda rosa sinistra",
  "block.minecraft.banner.stripe_downleft.white": "Banda bianca sinistra",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda zała sinistra",
  "block.minecraft.banner.stripe_downright.black": "Banda negra",
  "block.minecraft.banner.stripe_downright.blue": "Banda blè",
  "block.minecraft.banner.stripe_downright.brown": "Banda maron",
  "block.minecraft.banner.stripe_downright.cyan": "Banda sian",
  "block.minecraft.banner.stripe_downright.gray": "Banda griza",
  "block.minecraft.banner.stripe_downright.green": "Banda verda",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda sełeste",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda griza ciara",
  "block.minecraft.banner.stripe_downright.lime": "Banda lime",
  "block.minecraft.banner.stripe_downright.magenta": "Banda mazenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda naransa",
  "block.minecraft.banner.stripe_downright.pink": "Banda roza",
  "block.minecraft.banner.stripe_downright.purple": "Banda vioła",
  "block.minecraft.banner.stripe_downright.red": "Banda rosa",
  "block.minecraft.banner.stripe_downright.white": "Banda bianca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda zała",
  "block.minecraft.banner.stripe_left.black": "Pèrtega destra negra",
  "block.minecraft.banner.stripe_left.blue": "Pèrtega destra blè",
  "block.minecraft.banner.stripe_left.brown": "Pèrtega destra maron",
  "block.minecraft.banner.stripe_left.cyan": "Pèrtega destra sian",
  "block.minecraft.banner.stripe_left.gray": "Pèrtega destra griza",
  "block.minecraft.banner.stripe_left.green": "Pèrtega destra verda",
  "block.minecraft.banner.stripe_left.light_blue": "Pèrtega destra sełeste",
  "block.minecraft.banner.stripe_left.light_gray": "Pèrtega destra griza ciara",
  "block.minecraft.banner.stripe_left.lime": "Pèrtega destra lime",
  "block.minecraft.banner.stripe_left.magenta": "Pèrtega destra mazenta",
  "block.minecraft.banner.stripe_left.orange": "Pèrtega destra naransa",
  "block.minecraft.banner.stripe_left.pink": "Pèrtega destra roza",
  "block.minecraft.banner.stripe_left.purple": "Pèrtega destra vioła",
  "block.minecraft.banner.stripe_left.red": "Pèrtega destra rosa",
  "block.minecraft.banner.stripe_left.white": "Pèrtega destra bianca",
  "block.minecraft.banner.stripe_left.yellow": "Pèrtega destra zała",
  "block.minecraft.banner.stripe_middle.black": "Fasa negra",
  "block.minecraft.banner.stripe_middle.blue": "Fasa blè",
  "block.minecraft.banner.stripe_middle.brown": "Fasa maron",
  "block.minecraft.banner.stripe_middle.cyan": "Fasa sian",
  "block.minecraft.banner.stripe_middle.gray": "Fasa griza",
  "block.minecraft.banner.stripe_middle.green": "Fasa verda",
  "block.minecraft.banner.stripe_middle.light_blue": "Fasa sełeste",
  "block.minecraft.banner.stripe_middle.light_gray": "Fasa griza ciara",
  "block.minecraft.banner.stripe_middle.lime": "Fasa lime",
  "block.minecraft.banner.stripe_middle.magenta": "Fasa mazenta",
  "block.minecraft.banner.stripe_middle.orange": "Fasa naransa",
  "block.minecraft.banner.stripe_middle.pink": "Fasa roza",
  "block.minecraft.banner.stripe_middle.purple": "Fasa vioła",
  "block.minecraft.banner.stripe_middle.red": "Fasa rosa",
  "block.minecraft.banner.stripe_middle.white": "Fasa bianca",
  "block.minecraft.banner.stripe_middle.yellow": "Fasa zała",
  "block.minecraft.banner.stripe_right.black": "Pèrtega sinistra negra",
  "block.minecraft.banner.stripe_right.blue": "Pèrtega sinistra blè",
  "block.minecraft.banner.stripe_right.brown": "Pèrtega sinistra maron",
  "block.minecraft.banner.stripe_right.cyan": "Pèrtega sinistra sian",
  "block.minecraft.banner.stripe_right.gray": "Pèrtega sinistra griza",
  "block.minecraft.banner.stripe_right.green": "Pèrtega sinistra verda",
  "block.minecraft.banner.stripe_right.light_blue": "Pèrtega sinistra sełeste",
  "block.minecraft.banner.stripe_right.light_gray": "Pèrtega sinistra griza ciara",
  "block.minecraft.banner.stripe_right.lime": "Pèrtega sinistra lime",
  "block.minecraft.banner.stripe_right.magenta": "Pèrtega sinistra mazenta",
  "block.minecraft.banner.stripe_right.orange": "Pèrtega sinistra naransa",
  "block.minecraft.banner.stripe_right.pink": "Pèrtega sinistra roza",
  "block.minecraft.banner.stripe_right.purple": "Pèrtega sinistra vioła",
  "block.minecraft.banner.stripe_right.red": "Pèrtega sinistra rosa",
  "block.minecraft.banner.stripe_right.white": "Pèrtega sinistra bianca",
  "block.minecraft.banner.stripe_right.yellow": "Pèrtega sinistra zała",
  "block.minecraft.banner.stripe_top.black": "Sima negra",
  "block.minecraft.banner.stripe_top.blue": "Sima blè",
  "block.minecraft.banner.stripe_top.brown": "Sima maron",
  "block.minecraft.banner.stripe_top.cyan": "Sima sian",
  "block.minecraft.banner.stripe_top.gray": "Sima griza",
  "block.minecraft.banner.stripe_top.green": "Sima verda",
  "block.minecraft.banner.stripe_top.light_blue": "Sima sełeste",
  "block.minecraft.banner.stripe_top.light_gray": "Sima griza ciara",
  "block.minecraft.banner.stripe_top.lime": "Sima lime",
  "block.minecraft.banner.stripe_top.magenta": "Sima mazenta",
  "block.minecraft.banner.stripe_top.orange": "Sima naransa",
  "block.minecraft.banner.stripe_top.pink": "Sima roza",
  "block.minecraft.banner.stripe_top.purple": "Sima vioła",
  "block.minecraft.banner.stripe_top.red": "Sima rosa",
  "block.minecraft.banner.stripe_top.white": "Sima bianca",
  "block.minecraft.banner.stripe_top.yellow": "Sima zała",
  "block.minecraft.banner.triangle_bottom.black": "Ponta de negro",
  "block.minecraft.banner.triangle_bottom.blue": "Ponta de blè",
  "block.minecraft.banner.triangle_bottom.brown": "Ponta de maron",
  "block.minecraft.banner.triangle_bottom.cyan": "Ponta de sian",
  "block.minecraft.banner.triangle_bottom.gray": "Ponta de grizo",
  "block.minecraft.banner.triangle_bottom.green": "Ponta de verdo",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ponta de sełeste",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ponta de grizo ciaro",
  "block.minecraft.banner.triangle_bottom.lime": "Ponta de lime",
  "block.minecraft.banner.triangle_bottom.magenta": "Ponta de mazenta",
  "block.minecraft.banner.triangle_bottom.orange": "Ponta de naransa",
  "block.minecraft.banner.triangle_bottom.pink": "Ponta de roza",
  "block.minecraft.banner.triangle_bottom.purple": "Ponta de vioła",
  "block.minecraft.banner.triangle_bottom.red": "Ponta de roso",
  "block.minecraft.banner.triangle_bottom.white": "Ponta de bianco",
  "block.minecraft.banner.triangle_bottom.yellow": "Ponta de zało",
  "block.minecraft.banner.triangle_top.black": "Ponta roversa de negro",
  "block.minecraft.banner.triangle_top.blue": "Ponta roversa de blè",
  "block.minecraft.banner.triangle_top.brown": "Ponta roversa de maron",
  "block.minecraft.banner.triangle_top.cyan": "Ponta roversa de sian",
  "block.minecraft.banner.triangle_top.gray": "Ponta roversa de grizo",
  "block.minecraft.banner.triangle_top.green": "Ponta roversa de verdo",
  "block.minecraft.banner.triangle_top.light_blue": "Ponta roversa de sełeste",
  "block.minecraft.banner.triangle_top.light_gray": "Ponta roversa de grizo ciaro",
  "block.minecraft.banner.triangle_top.lime": "Ponta roversa de lime",
  "block.minecraft.banner.triangle_top.magenta": "Ponta roversa de mazenta",
  "block.minecraft.banner.triangle_top.orange": "Ponta roversa de naransa",
  "block.minecraft.banner.triangle_top.pink": "Ponta roversa de roza",
  "block.minecraft.banner.triangle_top.purple": "Ponta roversa de vioła",
  "block.minecraft.banner.triangle_top.red": "Ponta roversa de roso",
  "block.minecraft.banner.triangle_top.white": "Ponta roversa de bianco",
  "block.minecraft.banner.triangle_top.yellow": "Ponta roversa de zało",
  "block.minecraft.banner.triangles_bottom.black": "Piè dentà de negro",
  "block.minecraft.banner.triangles_bottom.blue": "Piè dentà de blè",
  "block.minecraft.banner.triangles_bottom.brown": "Piè dentà de maron",
  "block.minecraft.banner.triangles_bottom.cyan": "Piè dentà de sian",
  "block.minecraft.banner.triangles_bottom.gray": "Piè dentà de grizo",
  "block.minecraft.banner.triangles_bottom.green": "Piè dentà de verdo",
  "block.minecraft.banner.triangles_bottom.light_blue": "Piè dentà de sełeste",
  "block.minecraft.banner.triangles_bottom.light_gray": "Piè dentà de grizo ciaro",
  "block.minecraft.banner.triangles_bottom.lime": "Piè dentà de lime",
  "block.minecraft.banner.triangles_bottom.magenta": "Piè dentà de mazenta",
  "block.minecraft.banner.triangles_bottom.orange": "Piè dentà de naransa",
  "block.minecraft.banner.triangles_bottom.pink": "Piè dentà de roza",
  "block.minecraft.banner.triangles_bottom.purple": "Piè dentà de vioła",
  "block.minecraft.banner.triangles_bottom.red": "Piè dentà de roso",
  "block.minecraft.banner.triangles_bottom.white": "Seghetadura da baso bianca",
  "block.minecraft.banner.triangles_bottom.yellow": "Piè dentà de zało",
  "block.minecraft.banner.triangles_top.black": "Cao dentà de negro",
  "block.minecraft.banner.triangles_top.blue": "Cao dentà de blè",
  "block.minecraft.banner.triangles_top.brown": "Cao dentà de maron",
  "block.minecraft.banner.triangles_top.cyan": "Cao dentà de sian",
  "block.minecraft.banner.triangles_top.gray": "Cao dentà de grizo",
  "block.minecraft.banner.triangles_top.green": "Cao dentà de verdo",
  "block.minecraft.banner.triangles_top.light_blue": "Cao dentà de sełeste",
  "block.minecraft.banner.triangles_top.light_gray": "Cao dentà de grizo ciaro",
  "block.minecraft.banner.triangles_top.lime": "Cao dentà de lime",
  "block.minecraft.banner.triangles_top.magenta": "Cao dentà de mazenta",
  "block.minecraft.banner.triangles_top.orange": "Cao dentà de naransa",
  "block.minecraft.banner.triangles_top.pink": "Cao dentà de roza",
  "block.minecraft.banner.triangles_top.purple": "Cao dentà de vioła",
  "block.minecraft.banner.triangles_top.red": "Cao dentà de roso",
  "block.minecraft.banner.triangles_top.white": "Cao dentà de bianco",
  "block.minecraft.banner.triangles_top.yellow": "Cao dentà de zało",
  "block.minecraft.barrel": "Bóta",
  "block.minecraft.barrier": "Bariera",
  "block.minecraft.basalt": "Basalto",
  "block.minecraft.beacon": "Faro",
  "block.minecraft.beacon.primary": "Poder prinsipal",
  "block.minecraft.beacon.secondary": "Poder secondario",
  "block.minecraft.bed.no_sleep": "Te pol pisocàre solo de note o durante el tenporale",
  "block.minecraft.bed.not_safe": "A te pol mìa dormir deso: ghe ze dei mostri chi visin",
  "block.minecraft.bed.obstructed": "'Sto łeto el ze ocupà",
  "block.minecraft.bed.occupied": "Sto łeto el xe ocupà",
  "block.minecraft.bed.too_far_away": "No te pol mìa dormir chi: el leto l'è masa distante",
  "block.minecraft.bedrock": "Piera de'l fondo",
  "block.minecraft.bee_nest": "Avearo",
  "block.minecraft.beehive": "Avearo artifisial",
  "block.minecraft.beetroots": "Rave",
  "block.minecraft.bell": "Canpana",
  "block.minecraft.big_dripleaf": "Fojogiossa granda",
  "block.minecraft.big_dripleaf_stem": "Ganbo de fojogiossa granda",
  "block.minecraft.birch_button": "Boton de brédoła",
  "block.minecraft.birch_door": "Porta de brédoła",
  "block.minecraft.birch_fence": "Ringhiera de brédoła",
  "block.minecraft.birch_fence_gate": "Sarajo de brédoła",
  "block.minecraft.birch_hanging_sign": "Cartel de brédola picà",
  "block.minecraft.birch_leaves": "Foje de brédoła",
  "block.minecraft.birch_log": "Fusto de brédoła",
  "block.minecraft.birch_planks": "Ase de brédoła",
  "block.minecraft.birch_pressure_plate": "Pedana a presion de brédoła",
  "block.minecraft.birch_sapling": "Albareło de brédoła",
  "block.minecraft.birch_shelf": "Scansìa de Brédola",
  "block.minecraft.birch_sign": "Cartel de brédoła",
  "block.minecraft.birch_slab": "Łiston de brédoła",
  "block.minecraft.birch_stairs": "Scałe de brédoła",
  "block.minecraft.birch_trapdoor": "Rebalta de brédoła",
  "block.minecraft.birch_wall_hanging_sign": "Cartel de brédola picà a parede",
  "block.minecraft.birch_wall_sign": "Cartel de brédoła a muro",
  "block.minecraft.birch_wood": "Łenjo de brédoła",
  "block.minecraft.black_banner": "Gonfałon negro",
  "block.minecraft.black_bed": "Łeto negro",
  "block.minecraft.black_candle": "Candela negra",
  "block.minecraft.black_candle_cake": "Torta co' candela negra",
  "block.minecraft.black_carpet": "Tapéo negro",
  "block.minecraft.black_concrete": "Beton negro",
  "block.minecraft.black_concrete_powder": "Pólvar de beton negra",
  "block.minecraft.black_glazed_terracotta": "Teracota negra zmaltà",
  "block.minecraft.black_shulker_box": "Scàtoła de shulker negra",
  "block.minecraft.black_stained_glass": "Vero negro",
  "block.minecraft.black_stained_glass_pane": "Panel de vero negro",
  "block.minecraft.black_terracotta": "Teracota negra",
  "block.minecraft.black_wool": "Łana negra",
  "block.minecraft.blackstone": "Pieranegra",
  "block.minecraft.blackstone_slab": "Liston de Pieranegra",
  "block.minecraft.blackstone_stairs": "Scale de Pieranegra",
  "block.minecraft.blackstone_wall": "Mureta de Pieranegra",
  "block.minecraft.blast_furnace": "Gran fornaze",
  "block.minecraft.blue_banner": "Gonfałon blè",
  "block.minecraft.blue_bed": "Łeto blè",
  "block.minecraft.blue_candle": "Candela blé",
  "block.minecraft.blue_candle_cake": "Torta co' candela blé",
  "block.minecraft.blue_carpet": "Tapéo blè",
  "block.minecraft.blue_concrete": "Beton blè",
  "block.minecraft.blue_concrete_powder": "Pólvar de beton blè",
  "block.minecraft.blue_glazed_terracotta": "Teracota blè zmaltà",
  "block.minecraft.blue_ice": "Giaso blè",
  "block.minecraft.blue_orchid": "Orchidèa blè",
  "block.minecraft.blue_shulker_box": "Scàtoła de shulker blè",
  "block.minecraft.blue_stained_glass": "Vero blè",
  "block.minecraft.blue_stained_glass_pane": "Panel de vero blè",
  "block.minecraft.blue_terracotta": "Teracota blè",
  "block.minecraft.blue_wool": "Łana blè",
  "block.minecraft.bone_block": "Bloco de osi",
  "block.minecraft.bookshelf": "Librarìa",
  "block.minecraft.brain_coral": "Coral a sarvel",
  "block.minecraft.brain_coral_block": "Bloco de coral a sarvel",
  "block.minecraft.brain_coral_fan": "Gorgonia a sarvel",
  "block.minecraft.brain_coral_wall_fan": "Gorgonia a sarvel a parede",
  "block.minecraft.brewing_stand": "Łanbico",
  "block.minecraft.brick_slab": "Łiston de cuarełi",
  "block.minecraft.brick_stairs": "Scałe de cuarełi",
  "block.minecraft.brick_wall": "Mureta de cuarełi",
  "block.minecraft.bricks": "Cuarełi",
  "block.minecraft.brown_banner": "Gonfałon maron",
  "block.minecraft.brown_bed": "Łeto maron",
  "block.minecraft.brown_candle": "Candela maron",
  "block.minecraft.brown_candle_cake": "Torta co' candela maron",
  "block.minecraft.brown_carpet": "Tapéo maron",
  "block.minecraft.brown_concrete": "Beton maron",
  "block.minecraft.brown_concrete_powder": "Pólvar de beton maron",
  "block.minecraft.brown_glazed_terracotta": "Teracota maron zmaltà",
  "block.minecraft.brown_mushroom": "Fongo maron",
  "block.minecraft.brown_mushroom_block": "Bloco de fongo maron",
  "block.minecraft.brown_shulker_box": "Scàtoła de shulker maron",
  "block.minecraft.brown_stained_glass": "Vero maron",
  "block.minecraft.brown_stained_glass_pane": "Panel de vero maron",
  "block.minecraft.brown_terracotta": "Teracota maron",
  "block.minecraft.brown_wool": "Łana maron",
  "block.minecraft.bubble_column": "Cołona de bołe",
  "block.minecraft.bubble_coral": "Coral a bołe",
  "block.minecraft.bubble_coral_block": "Bloco de coral a bołe",
  "block.minecraft.bubble_coral_fan": "Gorgonia a bołe",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonia a bołe a parede",
  "block.minecraft.budding_amethyst": "Rabuto de Ametista",
  "block.minecraft.bush": "Giavasco",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Fior de cactus",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Calçite",
  "block.minecraft.calibrated_sculk_sensor": "Sensor de sculk calibrà",
  "block.minecraft.campfire": "Fogo da canpo",
  "block.minecraft.candle": "Candela",
  "block.minecraft.candle_cake": "Candela su torta",
  "block.minecraft.carrots": "Carote",
  "block.minecraft.cartography_table": "Banco de'l cartògrafo",
  "block.minecraft.carved_pumpkin": "Suca intajada",
  "block.minecraft.cauldron": "Calderon",
  "block.minecraft.cave_air": "Aria de grota",
  "block.minecraft.cave_vines": "Ranpeganti de le sprugie",
  "block.minecraft.cave_vines_plant": "Fusto de ranpegante de le sprugie",
  "block.minecraft.chain": "Cadena",
  "block.minecraft.chain_command_block": "Bloco comando a cadena",
  "block.minecraft.cherry_button": "Boton de çiresar",
  "block.minecraft.cherry_door": "Porta de çiresar",
  "block.minecraft.cherry_fence": "Ringhiera de çiresar",
  "block.minecraft.cherry_fence_gate": "Sarajo de çiresar",
  "block.minecraft.cherry_hanging_sign": "Cartel de çiresar picà",
  "block.minecraft.cherry_leaves": "Foje de çiresar",
  "block.minecraft.cherry_log": "Fusto de çiresar",
  "block.minecraft.cherry_planks": "Asse de çiresar",
  "block.minecraft.cherry_pressure_plate": "Pedana a pression de çiresar",
  "block.minecraft.cherry_sapling": "Buto de çiresar",
  "block.minecraft.cherry_shelf": "Scansìa de Çiresar",
  "block.minecraft.cherry_sign": "Cartel de çiresar",
  "block.minecraft.cherry_slab": "Liston de çiresar",
  "block.minecraft.cherry_stairs": "Scalini de çiresar",
  "block.minecraft.cherry_trapdoor": "Rebalta de çiresar",
  "block.minecraft.cherry_wall_hanging_sign": "Cartel de çiresar picà a parede",
  "block.minecraft.cherry_wall_sign": "Cartel de çiresar a parede",
  "block.minecraft.cherry_wood": "Legno de çiresar",
  "block.minecraft.chest": "Baùl",
  "block.minecraft.chipped_anvil": "Ancùzene schejà",
  "block.minecraft.chiseled_bookshelf": "Librarìa lavorada",
  "block.minecraft.chiseled_copper": "Rame lavorà",
  "block.minecraft.chiseled_deepslate": "Fondardesia Lavorada",
  "block.minecraft.chiseled_nether_bricks": "Cuarèi del Nether Lavoradi",
  "block.minecraft.chiseled_polished_blackstone": "Pieranegra Lustra Lavorada",
  "block.minecraft.chiseled_quartz_block": "Bloco de Cuarso Lavorà",
  "block.minecraft.chiseled_red_sandstone": "Arenaria rosa łavorà",
  "block.minecraft.chiseled_resin_bricks": "Cuarèi de caràsa lavoradi",
  "block.minecraft.chiseled_sandstone": "Arenaria łavorà",
  "block.minecraft.chiseled_stone_bricks": "Cuarełi de piera łavoradi",
  "block.minecraft.chiseled_tuff": "Tufo lavorà",
  "block.minecraft.chiseled_tuff_bricks": "Cuarèi de Tufo lavoradi",
  "block.minecraft.chorus_flower": "Fior de chorus",
  "block.minecraft.chorus_plant": "Pianta de chorus",
  "block.minecraft.clay": "Crea",
  "block.minecraft.closed_eyeblossom": "Ocidea serà",
  "block.minecraft.coal_block": "Bloco de Carbon",
  "block.minecraft.coal_ore": "Mineral de Carbon",
  "block.minecraft.coarse_dirt": "Tera seca",
  "block.minecraft.cobbled_deepslate": "Fondardesia Cogolada",
  "block.minecraft.cobbled_deepslate_slab": "Liston de Fondardesia Cogolada",
  "block.minecraft.cobbled_deepslate_stairs": "Scale de Fondardesia Cogolada",
  "block.minecraft.cobbled_deepslate_wall": "Mureta de Fondardesia Cogolada",
  "block.minecraft.cobblestone": "Piere",
  "block.minecraft.cobblestone_slab": "Łiston de piere",
  "block.minecraft.cobblestone_stairs": "Scałe de piera",
  "block.minecraft.cobblestone_wall": "Mureta de piere",
  "block.minecraft.cobweb": "Tełarina",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Bloco comando",
  "block.minecraft.comparator": "Conparador de redstone",
  "block.minecraft.composter": "Conpostador",
  "block.minecraft.conduit": "Conduto",
  "block.minecraft.copper_bars": "Bare de Rame",
  "block.minecraft.copper_block": "Bloco de Ramo",
  "block.minecraft.copper_bulb": "Bulbo de Rame",
  "block.minecraft.copper_chain": "Cadena de Rame",
  "block.minecraft.copper_chest": "Baùl de Rame",
  "block.minecraft.copper_door": "Porta de Rame",
  "block.minecraft.copper_golem_statue": "Statua de Golem de Rame",
  "block.minecraft.copper_grate": "Grada de Rame",
  "block.minecraft.copper_lantern": "Canfin de Rame",
  "block.minecraft.copper_ore": "Mineral de Ramo",
  "block.minecraft.copper_torch": "Torsa de Rame",
  "block.minecraft.copper_trapdoor": "Rebalta de Rame",
  "block.minecraft.copper_wall_torch": "Torsa de Rame a parede",
  "block.minecraft.cornflower": "Sełestin",
  "block.minecraft.cracked_deepslate_bricks": "Cuarèi de Fondardesia crepadi",
  "block.minecraft.cracked_deepslate_tiles": "Matonele de Fondardesia Crepade",
  "block.minecraft.cracked_nether_bricks": "Cuarèi del Nether Crepadi",
  "block.minecraft.cracked_polished_blackstone_bricks": "Cuarèi de Pieranegra Lustra Crepadi",
  "block.minecraft.cracked_stone_bricks": "Cuarełi de piera crepadi",
  "block.minecraft.crafter": "Craftador",
  "block.minecraft.crafting_table": "Banco da łaoro",
  "block.minecraft.creaking_heart": "Core Screçenante",
  "block.minecraft.creeper_head": "Testa de creeper",
  "block.minecraft.creeper_wall_head": "Testa de creeper a muro",
  "block.minecraft.crimson_button": "Boton crèmese",
  "block.minecraft.crimson_door": "Porta crèmese",
  "block.minecraft.crimson_fence": "Ringhiera crèmese",
  "block.minecraft.crimson_fence_gate": "Sarajo crèmese",
  "block.minecraft.crimson_fungus": "Fongo crèmese",
  "block.minecraft.crimson_hanging_sign": "Cartel crèmexe picà",
  "block.minecraft.crimson_hyphae": "Ife crèmese",
  "block.minecraft.crimson_nylium": "Neçelio crèmese",
  "block.minecraft.crimson_planks": "Asse crèmese",
  "block.minecraft.crimson_pressure_plate": "Pedana a pression crèmese",
  "block.minecraft.crimson_roots": "Raixe crèmese",
  "block.minecraft.crimson_shelf": "Scansìa Cremexe",
  "block.minecraft.crimson_sign": "Cartelo crèmese",
  "block.minecraft.crimson_slab": "Liston crèmese",
  "block.minecraft.crimson_stairs": "Scale crèmese",
  "block.minecraft.crimson_stem": "Ganbo crèmese",
  "block.minecraft.crimson_trapdoor": "Rebalta crèmese",
  "block.minecraft.crimson_wall_hanging_sign": "Cartel crèmexe picà a parede",
  "block.minecraft.crimson_wall_sign": "Cartelo crèmexe a parede",
  "block.minecraft.crying_obsidian": "Osidiana pianzente",
  "block.minecraft.cut_copper": "Ramo intajà",
  "block.minecraft.cut_copper_slab": "Liston de Ramo Intajà",
  "block.minecraft.cut_copper_stairs": "Scale de Ramo Intajà",
  "block.minecraft.cut_red_sandstone": "Arenaria rosa intajada",
  "block.minecraft.cut_red_sandstone_slab": "Łiston de arenaria rosa intajà",
  "block.minecraft.cut_sandstone": "Arenaria intajà",
  "block.minecraft.cut_sandstone_slab": "Łiston de arenaria intajà",
  "block.minecraft.cyan_banner": "Gonfałon sian",
  "block.minecraft.cyan_bed": "Łeto sian",
  "block.minecraft.cyan_candle": "Candela ciana",
  "block.minecraft.cyan_candle_cake": "Torta co' candela çiana",
  "block.minecraft.cyan_carpet": "Tapéo çian",
  "block.minecraft.cyan_concrete": "Beton sian",
  "block.minecraft.cyan_concrete_powder": "Pólvar de beton sian",
  "block.minecraft.cyan_glazed_terracotta": "Teracota sian zmaltà",
  "block.minecraft.cyan_shulker_box": "Scàtoła de shulker sian",
  "block.minecraft.cyan_stained_glass": "Vero sian",
  "block.minecraft.cyan_stained_glass_pane": "Panel de vero sian",
  "block.minecraft.cyan_terracotta": "Teracota sian",
  "block.minecraft.cyan_wool": "Łana sian",
  "block.minecraft.damaged_anvil": "Ancùzene danezada",
  "block.minecraft.dandelion": "Pisacan",
  "block.minecraft.dark_oak_button": "Boton de ròvare scura",
  "block.minecraft.dark_oak_door": "Porta de ròvare scura",
  "block.minecraft.dark_oak_fence": "Ringhiera de ròvare scura",
  "block.minecraft.dark_oak_fence_gate": "Sarajo de ròvare scura",
  "block.minecraft.dark_oak_hanging_sign": "Cartel de ròvare scura picà",
  "block.minecraft.dark_oak_leaves": "Foje de ròvare scura",
  "block.minecraft.dark_oak_log": "Fusto de ròvare scura",
  "block.minecraft.dark_oak_planks": "Ase de ròvare scura",
  "block.minecraft.dark_oak_pressure_plate": "Pedana a presion de ròvare scura",
  "block.minecraft.dark_oak_sapling": "Albareło de ròvare scura",
  "block.minecraft.dark_oak_shelf": "Scansìa de Rovare Scuro",
  "block.minecraft.dark_oak_sign": "Cartel de ròvare scura",
  "block.minecraft.dark_oak_slab": "Łiston de ròvare scura",
  "block.minecraft.dark_oak_stairs": "Scałe de ròvare scura",
  "block.minecraft.dark_oak_trapdoor": "Rebalta de ròvare",
  "block.minecraft.dark_oak_wall_hanging_sign": "Cartel de ròvare scura picà a parede",
  "block.minecraft.dark_oak_wall_sign": "Cartel de ròvare scura a parede",
  "block.minecraft.dark_oak_wood": "Łenjo de ròvare scura",
  "block.minecraft.dark_prismarine": "Prizmarin scuro",
  "block.minecraft.dark_prismarine_slab": "Łiston de prizmarin scuro",
  "block.minecraft.dark_prismarine_stairs": "Scałe de prizmarin scuro",
  "block.minecraft.daylight_detector": "Sensor de łuze diurna",
  "block.minecraft.dead_brain_coral": "Coral a sarvel morto",
  "block.minecraft.dead_brain_coral_block": "Bloco de coral a sarvel morto",
  "block.minecraft.dead_brain_coral_fan": "Gorgonia a sarvel morta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonia a sarvel a parede morta",
  "block.minecraft.dead_bubble_coral": "Coral a bołe morto",
  "block.minecraft.dead_bubble_coral_block": "Bloco de coral a bołe morto",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonia a bołe morta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonia a bołe a parede morta",
  "block.minecraft.dead_bush": "Rame seche",
  "block.minecraft.dead_fire_coral": "Coral de fogo morto",
  "block.minecraft.dead_fire_coral_block": "Bloco de coral de fogo morto",
  "block.minecraft.dead_fire_coral_fan": "Gorgonia de fogo morta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonia de fogo a parede morta",
  "block.minecraft.dead_horn_coral": "Coral a corno morto",
  "block.minecraft.dead_horn_coral_block": "Bloco de coral a corni morto",
  "block.minecraft.dead_horn_coral_fan": "Gorgonia a corni morta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonia a corni a parede morta",
  "block.minecraft.dead_tube_coral": "Coral a tubo morto",
  "block.minecraft.dead_tube_coral_block": "Bloco de coral a tubo morto",
  "block.minecraft.dead_tube_coral_fan": "Gorgonia a tubo morta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonia a tubo a parede morta",
  "block.minecraft.decorated_pot": "Vaso decorà",
  "block.minecraft.deepslate": "Fondardesia",
  "block.minecraft.deepslate_brick_slab": "Liston de Cuarèi de Fondardesia",
  "block.minecraft.deepslate_brick_stairs": "Scale de Cuarèi de Fondardesia",
  "block.minecraft.deepslate_brick_wall": "Mureta de Cuarèi de Fondardesia",
  "block.minecraft.deepslate_bricks": "Cuarèi de Fondardesia",
  "block.minecraft.deepslate_coal_ore": "Mineral de Carbon in Fondardesia",
  "block.minecraft.deepslate_copper_ore": "Mineral de Ramo in Fondardesia",
  "block.minecraft.deepslate_diamond_ore": "Mineral de Diamante in Fondardesia",
  "block.minecraft.deepslate_emerald_ore": "Mineral de Smeraldo in Fondardesia",
  "block.minecraft.deepslate_gold_ore": "Mineral de Oro in Fondardesia",
  "block.minecraft.deepslate_iron_ore": "Mineral de Fero in Fondardesia",
  "block.minecraft.deepslate_lapis_ore": "Mineral de Lapislàsaro in Fondardesia",
  "block.minecraft.deepslate_redstone_ore": "Mineral de Redstone in Fondardesia",
  "block.minecraft.deepslate_tile_slab": "Liston de Matonele de Fondardesia",
  "block.minecraft.deepslate_tile_stairs": "Scale de Matonele de Fondardesia",
  "block.minecraft.deepslate_tile_wall": "Mureta de Matonele de Fondardesia",
  "block.minecraft.deepslate_tiles": "Matonele de Fondardesia",
  "block.minecraft.detector_rail": "Roara rełevadora",
  "block.minecraft.diamond_block": "Bloco de Diamante",
  "block.minecraft.diamond_ore": "Mineral de Diamante",
  "block.minecraft.diorite": "Diorite",
  "block.minecraft.diorite_slab": "Łiston de diorite",
  "block.minecraft.diorite_stairs": "Scałe de diorite",
  "block.minecraft.diorite_wall": "Mureta de diorite",
  "block.minecraft.dirt": "Tera",
  "block.minecraft.dirt_path": "Sentier batùo",
  "block.minecraft.dispenser": "Despensador",
  "block.minecraft.dragon_egg": "Ovo de dragon",
  "block.minecraft.dragon_head": "Testa de dragon",
  "block.minecraft.dragon_wall_head": "Testa de dragon a muro",
  "block.minecraft.dried_ghast": "Ghast secà",
  "block.minecraft.dried_kelp_block": "Bloco de àlega seca",
  "block.minecraft.dripstone_block": "Bloco de pirołoto",
  "block.minecraft.dropper": "Dropador",
  "block.minecraft.emerald_block": "Bloco de Smeraldo",
  "block.minecraft.emerald_ore": "Mineral de Smeraldo",
  "block.minecraft.enchanting_table": "Banco da incantamenti",
  "block.minecraft.end_gateway": "Varco de'l End",
  "block.minecraft.end_portal": "Portal de'l End",
  "block.minecraft.end_portal_frame": "Tełar de'l portal de'l End",
  "block.minecraft.end_rod": "Zbara de'l End",
  "block.minecraft.end_stone": "Piera de'l End",
  "block.minecraft.end_stone_brick_slab": "Łiston de cuarełi de piera de'l End",
  "block.minecraft.end_stone_brick_stairs": "Scałe de cuarełi de piera de'l End",
  "block.minecraft.end_stone_brick_wall": "Mureta de cuarełi de piera de'l End",
  "block.minecraft.end_stone_bricks": "Cuarełi de piera de'l End",
  "block.minecraft.ender_chest": "Baùl de Ender",
  "block.minecraft.exposed_chiseled_copper": "Ramo laorà esponùo",
  "block.minecraft.exposed_copper": "Ramo Esponùo",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Lampada de ramo esponùo",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Porta de ramo esponùo",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Grada de ramo esponùo",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Rebalta de ramo esponùo",
  "block.minecraft.exposed_cut_copper": "Ramo Esponùo Intajà",
  "block.minecraft.exposed_cut_copper_slab": "Liston de Ramo Esponùo Intajà",
  "block.minecraft.exposed_cut_copper_stairs": "Scale de Ramo Esponùo Intajà",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Tera sapada",
  "block.minecraft.fern": "Felze",
  "block.minecraft.fire": "Fogo",
  "block.minecraft.fire_coral": "Coral de fogo",
  "block.minecraft.fire_coral_block": "Bloco de coral de fogo",
  "block.minecraft.fire_coral_fan": "Gorgonia de fogo",
  "block.minecraft.fire_coral_wall_fan": "Gorgonia de fogo a parede",
  "block.minecraft.firefly_bush": "Giavasco de luxarole",
  "block.minecraft.fletching_table": "Banco de l'arser",
  "block.minecraft.flower_pot": "Vazo da fiori",
  "block.minecraft.flowering_azalea": "Azalea fiorìa",
  "block.minecraft.flowering_azalea_leaves": "Foje de azalea fiorìa",
  "block.minecraft.frogspawn": "Ovi de Rana",
  "block.minecraft.frosted_ice": "Acua giasada",
  "block.minecraft.furnace": "Fornaze",
  "block.minecraft.gilded_blackstone": "Pieranegra Indorada",
  "block.minecraft.glass": "Vero",
  "block.minecraft.glass_pane": "Panel de vero",
  "block.minecraft.glow_lichen": "Lichen luxente",
  "block.minecraft.glowstone": "Zluzorite",
  "block.minecraft.gold_block": "Bloco de Oro",
  "block.minecraft.gold_ore": "Mineral de Oro",
  "block.minecraft.golden_dandelion": "Pissacan Indorà",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Łiston de granito",
  "block.minecraft.granite_stairs": "Scałe de granito",
  "block.minecraft.granite_wall": "Mureta de granito",
  "block.minecraft.grass": "Erba",
  "block.minecraft.grass_block": "Bloco de erba",
  "block.minecraft.gravel": "Giara",
  "block.minecraft.gray_banner": "Gonfałon grizo",
  "block.minecraft.gray_bed": "Leto griso",
  "block.minecraft.gray_candle": "Candela grisa",
  "block.minecraft.gray_candle_cake": "Torta co' candela grisa",
  "block.minecraft.gray_carpet": "Tapéo griso",
  "block.minecraft.gray_concrete": "Beton grizo",
  "block.minecraft.gray_concrete_powder": "Pólvar de beton griza",
  "block.minecraft.gray_glazed_terracotta": "Teracota griza zmaltà",
  "block.minecraft.gray_shulker_box": "Scàtoła de shulker griza",
  "block.minecraft.gray_stained_glass": "Vero grizo",
  "block.minecraft.gray_stained_glass_pane": "Panel de vero grizo",
  "block.minecraft.gray_terracotta": "Teracota griza",
  "block.minecraft.gray_wool": "Łana griza",
  "block.minecraft.green_banner": "Gonfałon verdo",
  "block.minecraft.green_bed": "Łeto verdo",
  "block.minecraft.green_candle": "Candela verda",
  "block.minecraft.green_candle_cake": "Torta co' candela maron",
  "block.minecraft.green_carpet": "Tapéo verdo",
  "block.minecraft.green_concrete": "Beton verdo",
  "block.minecraft.green_concrete_powder": "Pólvar de beton verda",
  "block.minecraft.green_glazed_terracotta": "Teracota verda zmaltà",
  "block.minecraft.green_shulker_box": "Scàtoła de shulker verda",
  "block.minecraft.green_stained_glass": "Vero verdo",
  "block.minecraft.green_stained_glass_pane": "Panel de vero verdo",
  "block.minecraft.green_terracotta": "Teracota verda",
  "block.minecraft.green_wool": "Łana verda",
  "block.minecraft.grindstone": "Moła",
  "block.minecraft.hanging_roots": "Raise pendente",
  "block.minecraft.hay_block": "Bała de fen",
  "block.minecraft.heavy_core": "Nucleo Peso",
  "block.minecraft.heavy_weighted_pressure_plate": "Pedana a pezo (pezi grosi)",
  "block.minecraft.honey_block": "Bloco de mel",
  "block.minecraft.honeycomb_block": "Bloco de caraze",
  "block.minecraft.hopper": "Tramoza",
  "block.minecraft.horn_coral": "Coral a corni",
  "block.minecraft.horn_coral_block": "Bloco de coral a corni",
  "block.minecraft.horn_coral_fan": "Gorgonia a corni",
  "block.minecraft.horn_coral_wall_fan": "Gorgonia a corni a parede",
  "block.minecraft.ice": "Giaso",
  "block.minecraft.infested_chiseled_stone_bricks": "Cuarełi de piera łavoradi infestadi",
  "block.minecraft.infested_cobblestone": "Piere infestade",
  "block.minecraft.infested_cracked_stone_bricks": "Cuarełi de piera crepè infestadi",
  "block.minecraft.infested_deepslate": "Fondardesia infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Cuarełi de piera musciadi infestadi",
  "block.minecraft.infested_stone": "Piera infestada",
  "block.minecraft.infested_stone_bricks": "Cuarełi de piera infestadi",
  "block.minecraft.iron_bars": "Sbare de Fero",
  "block.minecraft.iron_block": "Bloco de Fero",
  "block.minecraft.iron_chain": "Cadena de Fero",
  "block.minecraft.iron_door": "Porta de Fero",
  "block.minecraft.iron_ore": "Mineral de Fero",
  "block.minecraft.iron_trapdoor": "Rebalta de Fero",
  "block.minecraft.jack_o_lantern": "Łanterna de suca",
  "block.minecraft.jigsaw": "Bloco de architeto",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Boton de ła jungla",
  "block.minecraft.jungle_door": "Porta de ła jungla",
  "block.minecraft.jungle_fence": "Ringhiera de ła jungla",
  "block.minecraft.jungle_fence_gate": "Sarajo de ła jungla",
  "block.minecraft.jungle_hanging_sign": "Cartel de la jungla picà",
  "block.minecraft.jungle_leaves": "Foje de ła jungla",
  "block.minecraft.jungle_log": "Fusto de ła jungla",
  "block.minecraft.jungle_planks": "Ase de ła jungla",
  "block.minecraft.jungle_pressure_plate": "Pedana a presion de ła jungla",
  "block.minecraft.jungle_sapling": "Albareło de ła jungla",
  "block.minecraft.jungle_shelf": "Scansìa de la Jungla",
  "block.minecraft.jungle_sign": "Cartel de ła jungla",
  "block.minecraft.jungle_slab": "Łiston de ła jungla",
  "block.minecraft.jungle_stairs": "Scałe de ła jungla",
  "block.minecraft.jungle_trapdoor": "Rebalta de ła jungla",
  "block.minecraft.jungle_wall_hanging_sign": "Cartel de la jungla picà a parede",
  "block.minecraft.jungle_wall_sign": "Cartel de ła jungla a parede",
  "block.minecraft.jungle_wood": "Łenjo de ła jungla",
  "block.minecraft.kelp": "Àlega",
  "block.minecraft.kelp_plant": "Ganbo de àlega",
  "block.minecraft.ladder": "Scałion",
  "block.minecraft.lantern": "Łume",
  "block.minecraft.lapis_block": "Bloco de Lapislàsari",
  "block.minecraft.lapis_ore": "Mineral de Lapislàsaro",
  "block.minecraft.large_amethyst_bud": "Bòcolo de ametista grando",
  "block.minecraft.large_fern": "Felse granda",
  "block.minecraft.lava": "Łava",
  "block.minecraft.lava_cauldron": "Calderon de lava",
  "block.minecraft.leaf_litter": "Foje morte",
  "block.minecraft.lectern": "Letorin",
  "block.minecraft.lever": "Łieva",
  "block.minecraft.light": "Luxe",
  "block.minecraft.light_blue_banner": "Gonfałon sełeste",
  "block.minecraft.light_blue_bed": "Łeto sełeste",
  "block.minecraft.light_blue_candle": "Candela çeleste",
  "block.minecraft.light_blue_candle_cake": "Torta co' candela çeleste",
  "block.minecraft.light_blue_carpet": "Tapéo çeleste",
  "block.minecraft.light_blue_concrete": "Beton sełeste",
  "block.minecraft.light_blue_concrete_powder": "Pólvar de beton sełeste",
  "block.minecraft.light_blue_glazed_terracotta": "Teracota sełeste zmaltà",
  "block.minecraft.light_blue_shulker_box": "Scàtoła de shulker sełeste",
  "block.minecraft.light_blue_stained_glass": "Vero sełeste",
  "block.minecraft.light_blue_stained_glass_pane": "Panel de vero sełeste",
  "block.minecraft.light_blue_terracotta": "Teracota sełeste",
  "block.minecraft.light_blue_wool": "Łana sełeste",
  "block.minecraft.light_gray_banner": "Gonfałon grizo ciaro",
  "block.minecraft.light_gray_bed": "Łeto grizo ciaro",
  "block.minecraft.light_gray_candle": "Candela grisa ciara",
  "block.minecraft.light_gray_candle_cake": "Torta co' candela grisa ciara",
  "block.minecraft.light_gray_carpet": "Tapéo griso ciaro",
  "block.minecraft.light_gray_concrete": "Beton grizo ciaro",
  "block.minecraft.light_gray_concrete_powder": "Pólvar de beton griza ciara",
  "block.minecraft.light_gray_glazed_terracotta": "Teracota griza ciara zmaltà",
  "block.minecraft.light_gray_shulker_box": "Scàtoła de shulker griza ciara",
  "block.minecraft.light_gray_stained_glass": "Vero grizo ciaro",
  "block.minecraft.light_gray_stained_glass_pane": "Panel de vero grizo ciaro",
  "block.minecraft.light_gray_terracotta": "Teracota griza ciara",
  "block.minecraft.light_gray_wool": "Łana griza ciara",
  "block.minecraft.light_weighted_pressure_plate": "Pedana a pezo (pezi picenini)",
  "block.minecraft.lightning_rod": "Parafulmen",
  "block.minecraft.lilac": "Secomoro",
  "block.minecraft.lily_of_the_valley": "Łiłio",
  "block.minecraft.lily_pad": "Tageri",
  "block.minecraft.lime_banner": "Gonfałon lime",
  "block.minecraft.lime_bed": "Łeto lime",
  "block.minecraft.lime_candle": "Candela lime",
  "block.minecraft.lime_candle_cake": "Torta co' candela lime",
  "block.minecraft.lime_carpet": "Tapéo lime",
  "block.minecraft.lime_concrete": "Beton lime",
  "block.minecraft.lime_concrete_powder": "Pólvar de beton lime",
  "block.minecraft.lime_glazed_terracotta": "Teracota lime zmaltà",
  "block.minecraft.lime_shulker_box": "Scàtoła de shulker lime",
  "block.minecraft.lime_stained_glass": "Vero lime",
  "block.minecraft.lime_stained_glass_pane": "Panel de vero lime",
  "block.minecraft.lime_terracotta": "Teracota lime",
  "block.minecraft.lime_wool": "Łana lime",
  "block.minecraft.lodestone": "Magnetite",
  "block.minecraft.loom": "Tełar",
  "block.minecraft.magenta_banner": "Gonfałon mazenta",
  "block.minecraft.magenta_bed": "Łeto mazenta",
  "block.minecraft.magenta_candle": "Candela magenta",
  "block.minecraft.magenta_candle_cake": "Torta co' candela magenta",
  "block.minecraft.magenta_carpet": "Tapéo magenta",
  "block.minecraft.magenta_concrete": "Beton mazenta",
  "block.minecraft.magenta_concrete_powder": "Pólvar de beton mazenta",
  "block.minecraft.magenta_glazed_terracotta": "Teracota mazenta zmaltà",
  "block.minecraft.magenta_shulker_box": "Scàtoła de shulker mazenta",
  "block.minecraft.magenta_stained_glass": "Vero mazenta",
  "block.minecraft.magenta_stained_glass_pane": "Panel de vero mazenta",
  "block.minecraft.magenta_terracotta": "Teracota mazenta",
  "block.minecraft.magenta_wool": "Łana mazenta",
  "block.minecraft.magma_block": "Bloco de magma",
  "block.minecraft.mangrove_button": "Boton de Mangrovia",
  "block.minecraft.mangrove_door": "Porta de Mangrovia",
  "block.minecraft.mangrove_fence": "Ringhiera de Mangrovia",
  "block.minecraft.mangrove_fence_gate": "Sarajo de Mangrovia",
  "block.minecraft.mangrove_hanging_sign": "Cartel de la mangrovia picà",
  "block.minecraft.mangrove_leaves": "Foje de Mangrovia",
  "block.minecraft.mangrove_log": "Fusto de Mangrovia",
  "block.minecraft.mangrove_planks": "Ase de Mangrovia",
  "block.minecraft.mangrove_pressure_plate": "Pedana a presion de Mangrovia",
  "block.minecraft.mangrove_propagule": "Propagulo de Mangrovia",
  "block.minecraft.mangrove_roots": "Radise de Mangrovia",
  "block.minecraft.mangrove_shelf": "Scansìa de Mangrovia",
  "block.minecraft.mangrove_sign": "Cartel de la mangrovia",
  "block.minecraft.mangrove_slab": "Łiston de Mangrovia",
  "block.minecraft.mangrove_stairs": "Scałe de Mangrovia",
  "block.minecraft.mangrove_trapdoor": "Rebalta de Mangrovia",
  "block.minecraft.mangrove_wall_hanging_sign": "Cartel de la mangrovia picà a parede",
  "block.minecraft.mangrove_wall_sign": "Cartel de mangrovia a parede",
  "block.minecraft.mangrove_wood": "Legno de Mangrovia",
  "block.minecraft.medium_amethyst_bud": "Bòcolo de ametista medio",
  "block.minecraft.melon": "Inguria",
  "block.minecraft.melon_stem": "Pianta de inguria",
  "block.minecraft.moss_block": "Bloco de muscio",
  "block.minecraft.moss_carpet": "Tapéo de muscio",
  "block.minecraft.mossy_cobblestone": "Piere musciade",
  "block.minecraft.mossy_cobblestone_slab": "Łiston de piere musciade",
  "block.minecraft.mossy_cobblestone_stairs": "Scałe de piera musciada",
  "block.minecraft.mossy_cobblestone_wall": "Mureta de piere musciade",
  "block.minecraft.mossy_stone_brick_slab": "Łiston de cuarełi de piera musciadi",
  "block.minecraft.mossy_stone_brick_stairs": "Scałe de cuarełi de piera musciadi",
  "block.minecraft.mossy_stone_brick_wall": "Mureta de cuarełi de piera musciada",
  "block.minecraft.mossy_stone_bricks": "Cuarełi de piera musciadi",
  "block.minecraft.moving_piston": "Piston drio móvarse",
  "block.minecraft.mud": "Fango",
  "block.minecraft.mud_brick_slab": "Łiston de cuareli de Fango",
  "block.minecraft.mud_brick_stairs": "Scałe de cuareli de Fango",
  "block.minecraft.mud_brick_wall": "Mureta de Fango",
  "block.minecraft.mud_bricks": "Cuareli de Fango",
  "block.minecraft.muddy_mangrove_roots": "Radice fangosa de Mangrovia",
  "block.minecraft.mushroom_stem": "Ganbo de fongo",
  "block.minecraft.mycelium": "Micełio",
  "block.minecraft.nether_brick_fence": "Ringhiera de cuarełi de'l Nether",
  "block.minecraft.nether_brick_slab": "Łiston de cuarełi de'l Nether",
  "block.minecraft.nether_brick_stairs": "Scałe de cuarełi de'l Nether",
  "block.minecraft.nether_brick_wall": "Mureta de cuarełi de'l Nether",
  "block.minecraft.nether_bricks": "Cuarełi de'l Nether",
  "block.minecraft.nether_gold_ore": "Mineral de Oro del Nether",
  "block.minecraft.nether_portal": "Portal de'l Nether",
  "block.minecraft.nether_quartz_ore": "Mineral de Cuarso del Nether",
  "block.minecraft.nether_sprouts": "Buti del Nether",
  "block.minecraft.nether_wart": "Poro de'l Nether",
  "block.minecraft.nether_wart_block": "Bloco de pori de'l Nether",
  "block.minecraft.netherite_block": "Bloco de netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloco sonoro",
  "block.minecraft.oak_button": "Boton de ròvare",
  "block.minecraft.oak_door": "Porta de ròvare",
  "block.minecraft.oak_fence": "Ringhiera de ròvare",
  "block.minecraft.oak_fence_gate": "Sarajo de ròvare",
  "block.minecraft.oak_hanging_sign": "Cartel de ròvare picà",
  "block.minecraft.oak_leaves": "Foje de ròvare",
  "block.minecraft.oak_log": "Fusto de ròvare",
  "block.minecraft.oak_planks": "Ase de ròvare",
  "block.minecraft.oak_pressure_plate": "Pedana a presion de ròvare",
  "block.minecraft.oak_sapling": "Albareło de ròvare",
  "block.minecraft.oak_shelf": "Scansìa de Rovare",
  "block.minecraft.oak_sign": "Cartel de ròvare",
  "block.minecraft.oak_slab": "Łiston de ròvare",
  "block.minecraft.oak_stairs": "Scałe de ròvare",
  "block.minecraft.oak_trapdoor": "Rebalta de ròvare",
  "block.minecraft.oak_wall_hanging_sign": "Cartel de ròvare picà a parede",
  "block.minecraft.oak_wall_sign": "Cartel de ròvare a parede",
  "block.minecraft.oak_wood": "Łenjo de ròvare",
  "block.minecraft.observer": "Oservador",
  "block.minecraft.obsidian": "Osidiana",
  "block.minecraft.ochre_froglight": "Lumerana Ocra",
  "block.minecraft.ominous_banner": "Gonfałon de ła dezdita",
  "block.minecraft.open_eyeblossom": "Ocidea verta",
  "block.minecraft.orange_banner": "Gonfałon naransa",
  "block.minecraft.orange_bed": "Łeto naransa",
  "block.minecraft.orange_candle": "Candela naransa",
  "block.minecraft.orange_candle_cake": "Torta co' candela naransa",
  "block.minecraft.orange_carpet": "Tapéo naransa",
  "block.minecraft.orange_concrete": "Beton naransa",
  "block.minecraft.orange_concrete_powder": "Pólvar de beton naransa",
  "block.minecraft.orange_glazed_terracotta": "Teracota naransa zmaltà",
  "block.minecraft.orange_shulker_box": "Scàtoła de shulker naransa",
  "block.minecraft.orange_stained_glass": "Vero naransa",
  "block.minecraft.orange_stained_glass_pane": "Panel de vero naransa",
  "block.minecraft.orange_terracotta": "Teracota naransa",
  "block.minecraft.orange_tulip": "Tułipan naransa",
  "block.minecraft.orange_wool": "Łana naransa",
  "block.minecraft.oxeye_daisy": "Margarita",
  "block.minecraft.oxidized_chiseled_copper": "Ramo ossidà laorà",
  "block.minecraft.oxidized_copper": "Ramo Ossidà",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Lampada de ramo ossidà",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Porta de ramo ossidà",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Grada de ramo ossidà",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Rebalta de ramo ossidà",
  "block.minecraft.oxidized_cut_copper": "Ramo Ossidà Intajà",
  "block.minecraft.oxidized_cut_copper_slab": "Liston de Ramo Ossidà Intajà",
  "block.minecraft.oxidized_cut_copper_stairs": "Scale de Ramo Ossidà Intajà",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Giaso macà",
  "block.minecraft.packed_mud": "Fango macà",
  "block.minecraft.pale_hanging_moss": "Mus'cio pendente pałido",
  "block.minecraft.pale_moss_block": "Bloco de mus'cio pałido",
  "block.minecraft.pale_moss_carpet": "Tapeto de mus'cio pałido",
  "block.minecraft.pale_oak_button": "Boton de ròvare pałido",
  "block.minecraft.pale_oak_door": "Porta de ròvare pałida",
  "block.minecraft.pale_oak_fence": "Ringhiera de ròvare pałida",
  "block.minecraft.pale_oak_fence_gate": "Sarajo de ròvare pałida",
  "block.minecraft.pale_oak_hanging_sign": "Cartel de ròvare pałido",
  "block.minecraft.pale_oak_leaves": "Foje de ròvare pałido",
  "block.minecraft.pale_oak_log": "Fusto de ròvare pałido",
  "block.minecraft.pale_oak_planks": "Ase de ròvare pałido",
  "block.minecraft.pale_oak_pressure_plate": "Pedana a presion de ròvare pałido",
  "block.minecraft.pale_oak_sapling": "Albareło de ròvare pałido",
  "block.minecraft.pale_oak_shelf": "Scansìa de Rovare Pàlido",
  "block.minecraft.pale_oak_sign": "Cartel de ròvare pałido",
  "block.minecraft.pale_oak_slab": "Łiston de ròvare pałido",
  "block.minecraft.pale_oak_stairs": "Scałe de ròvare pałido",
  "block.minecraft.pale_oak_trapdoor": "Rebalta de ròvare pałido",
  "block.minecraft.pale_oak_wall_hanging_sign": "Cartel de ròvare pałido picà a parede",
  "block.minecraft.pale_oak_wall_sign": "Cartel de ròvare pałido a parede",
  "block.minecraft.pale_oak_wood": "Łenjo de ròvare pałido",
  "block.minecraft.pearlescent_froglight": "Lumerana Viola",
  "block.minecraft.peony": "Fołanja",
  "block.minecraft.petrified_oak_slab": "Łiston de ròvare piedrifegà",
  "block.minecraft.piglin_head": "Testa de Piglin",
  "block.minecraft.piglin_wall_head": "Testa de Piglin a parede",
  "block.minecraft.pink_banner": "Gonfałon roza",
  "block.minecraft.pink_bed": "Łeto roza",
  "block.minecraft.pink_candle": "Candela rosa",
  "block.minecraft.pink_candle_cake": "Torta co' candela rosa",
  "block.minecraft.pink_carpet": "Tapéo rosa",
  "block.minecraft.pink_concrete": "Beton roza",
  "block.minecraft.pink_concrete_powder": "Pólvar de beton roza",
  "block.minecraft.pink_glazed_terracotta": "Teracota roza zmaltà",
  "block.minecraft.pink_petals": "Pètali rosa",
  "block.minecraft.pink_shulker_box": "Scàtoła de shulker roza",
  "block.minecraft.pink_stained_glass": "Vero roza",
  "block.minecraft.pink_stained_glass_pane": "Panel de vero roza",
  "block.minecraft.pink_terracotta": "Teracota roza",
  "block.minecraft.pink_tulip": "Tułipan roza",
  "block.minecraft.pink_wool": "Łana roza",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Testa de piston",
  "block.minecraft.pitcher_crop": "Coltura de pianta bocal",
  "block.minecraft.pitcher_plant": "Pianta bocal",
  "block.minecraft.player_head": "Testa de zugador",
  "block.minecraft.player_head.named": "Testa de %s",
  "block.minecraft.player_wall_head": "Testa de zugador a muro",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Pirołoto",
  "block.minecraft.polished_andesite": "Andezite łustra",
  "block.minecraft.polished_andesite_slab": "Łiston de andezite łustra",
  "block.minecraft.polished_andesite_stairs": "Scałe de andezite łustra",
  "block.minecraft.polished_basalt": "Basalto lustro",
  "block.minecraft.polished_blackstone": "Pieranegra Lustra",
  "block.minecraft.polished_blackstone_brick_slab": "Liston de Cuarèi de Pieranegra Lustra",
  "block.minecraft.polished_blackstone_brick_stairs": "Scale de Cuarèi de Pieranegra Lustra",
  "block.minecraft.polished_blackstone_brick_wall": "Mureta de Cuarèi de Pieranegra Lustra",
  "block.minecraft.polished_blackstone_bricks": "Cuarèi de Pieranegra Lustra",
  "block.minecraft.polished_blackstone_button": "Boton de Pieranegra Lustra",
  "block.minecraft.polished_blackstone_pressure_plate": "Pedana a pression de Pieranegra Lustra",
  "block.minecraft.polished_blackstone_slab": "Liston de Pieranegra Lustra",
  "block.minecraft.polished_blackstone_stairs": "Scale de Pieranegra Lustra",
  "block.minecraft.polished_blackstone_wall": "Mureta de Pieranegra Lustra",
  "block.minecraft.polished_deepslate": "Fondardesia lustra",
  "block.minecraft.polished_deepslate_slab": "Liston de Fondardesia Lustra",
  "block.minecraft.polished_deepslate_stairs": "Scale de Fondardesia Lustra",
  "block.minecraft.polished_deepslate_wall": "Mureta de Fondardesia Lustra",
  "block.minecraft.polished_diorite": "Diorite łustra",
  "block.minecraft.polished_diorite_slab": "Łiston de diorite łustra",
  "block.minecraft.polished_diorite_stairs": "Scałe de diorite łustra",
  "block.minecraft.polished_granite": "Granito łustro",
  "block.minecraft.polished_granite_slab": "Łiston de granito łustro",
  "block.minecraft.polished_granite_stairs": "Scałe de granito łustro",
  "block.minecraft.polished_tuff": "Tufo lustro",
  "block.minecraft.polished_tuff_slab": "Liston de Tufo lustro",
  "block.minecraft.polished_tuff_stairs": "Scale de Tufo lustro",
  "block.minecraft.polished_tuff_wall": "Mureta de Tufo lustro",
  "block.minecraft.poppy": "Papàvaro",
  "block.minecraft.potatoes": "Patate",
  "block.minecraft.potted_acacia_sapling": "Albareło de acasia in vazo",
  "block.minecraft.potted_allium": "Fior de ajo in vazo",
  "block.minecraft.potted_azalea_bush": "Vaso co' azalèa",
  "block.minecraft.potted_azure_bluet": "Fior de canpo in vazo",
  "block.minecraft.potted_bamboo": "Canavera in vazo",
  "block.minecraft.potted_birch_sapling": "Albareło de brédoła in vaso",
  "block.minecraft.potted_blue_orchid": "Orchidèa blè in vaso",
  "block.minecraft.potted_brown_mushroom": "Fongo maron in vazo",
  "block.minecraft.potted_cactus": "Cactus in vazo",
  "block.minecraft.potted_cherry_sapling": "Albarelo de çiresar in vaso",
  "block.minecraft.potted_closed_eyeblossom": "Ocidea serà in vaso",
  "block.minecraft.potted_cornflower": "Sełestin in vazo",
  "block.minecraft.potted_crimson_fungus": "Fongo crèmese in vaso",
  "block.minecraft.potted_crimson_roots": "Raixe crèmese in vaso",
  "block.minecraft.potted_dandelion": "Pisacan in vazo",
  "block.minecraft.potted_dark_oak_sapling": "Albareło de ròvare scura in vazo",
  "block.minecraft.potted_dead_bush": "Albareło seco in vazo",
  "block.minecraft.potted_fern": "Felze in vazo",
  "block.minecraft.potted_flowering_azalea_bush": "Vaso co' azalèa in fior",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Albareło de ła jungla in vaso",
  "block.minecraft.potted_lily_of_the_valley": "Łiłio in vazo",
  "block.minecraft.potted_mangrove_propagule": "Propagulo de Mangrovia in vazo",
  "block.minecraft.potted_oak_sapling": "Albareło de ròvare in vaso",
  "block.minecraft.potted_open_eyeblossom": "Ocidea verta in vaso",
  "block.minecraft.potted_orange_tulip": "Tułipan naransa in vazo",
  "block.minecraft.potted_oxeye_daisy": "Margarita in vazo",
  "block.minecraft.potted_pale_oak_sapling": "Albareło de ròvare pałido in vazo",
  "block.minecraft.potted_pink_tulip": "Tułipan roza in vazo",
  "block.minecraft.potted_poppy": "Papàvaro in vazo",
  "block.minecraft.potted_red_mushroom": "Fongo roso in vazo",
  "block.minecraft.potted_red_tulip": "Tułipan roso in vazo",
  "block.minecraft.potted_spruce_sapling": "Albareło de avede in vaso",
  "block.minecraft.potted_torchflower": "Luxoflora in vaso",
  "block.minecraft.potted_warped_fungus": "Fongo strùpio in vaso",
  "block.minecraft.potted_warped_roots": "Raixe strùpie in vaso",
  "block.minecraft.potted_white_tulip": "Tułipan bianco in vazo",
  "block.minecraft.potted_wither_rose": "Roza de Wither in vazo",
  "block.minecraft.powder_snow": "Neve polvarosa",
  "block.minecraft.powder_snow_cauldron": "Calderon de neve polvarosa",
  "block.minecraft.powered_rail": "Roara ałimentada",
  "block.minecraft.prismarine": "Prizmarin",
  "block.minecraft.prismarine_brick_slab": "Łiston de cuarełi de prizmarin",
  "block.minecraft.prismarine_brick_stairs": "Scałe de cuarełi de prizmarin",
  "block.minecraft.prismarine_bricks": "Cuarełi de prizmarin",
  "block.minecraft.prismarine_slab": "Łiston de prizmarin",
  "block.minecraft.prismarine_stairs": "Scałe de prizmarin",
  "block.minecraft.prismarine_wall": "Mureta de prizmarin",
  "block.minecraft.pumpkin": "Suca",
  "block.minecraft.pumpkin_stem": "Pianta de suca",
  "block.minecraft.purple_banner": "Gonfałon vioła",
  "block.minecraft.purple_bed": "Łeto vioła",
  "block.minecraft.purple_candle": "Candela viola",
  "block.minecraft.purple_candle_cake": "Torta co' candela viola",
  "block.minecraft.purple_carpet": "Tapéo vioła",
  "block.minecraft.purple_concrete": "Beton vioła",
  "block.minecraft.purple_concrete_powder": "Pólvar de beton vioła",
  "block.minecraft.purple_glazed_terracotta": "Teracota vioła zmaltà",
  "block.minecraft.purple_shulker_box": "Scàtoła de shulker vioła",
  "block.minecraft.purple_stained_glass": "Vero vioła",
  "block.minecraft.purple_stained_glass_pane": "Panel de vero vioła",
  "block.minecraft.purple_terracotta": "Teracota vioła",
  "block.minecraft.purple_wool": "Łana vioła",
  "block.minecraft.purpur_block": "Purpur",
  "block.minecraft.purpur_pillar": "Piłastro de purpur",
  "block.minecraft.purpur_slab": "Łiston de purpur",
  "block.minecraft.purpur_stairs": "Scałe de purpur",
  "block.minecraft.quartz_block": "Bloco de Cuarso",
  "block.minecraft.quartz_bricks": "Cuarèi de Cuarso",
  "block.minecraft.quartz_pillar": "Pilastro de Cuarso",
  "block.minecraft.quartz_slab": "Liston de Cuarso",
  "block.minecraft.quartz_stairs": "Scale de Cuarso",
  "block.minecraft.rail": "Roara",
  "block.minecraft.raw_copper_block": "Bloco de Ramo Grezo",
  "block.minecraft.raw_gold_block": "Bloco de Oro Grezo",
  "block.minecraft.raw_iron_block": "Bloco de Fero Grezo",
  "block.minecraft.red_banner": "Gonfałon roso",
  "block.minecraft.red_bed": "Łeto roso",
  "block.minecraft.red_candle": "Candela rossa",
  "block.minecraft.red_candle_cake": "Torta co' candela rossa",
  "block.minecraft.red_carpet": "Tapéo rosso",
  "block.minecraft.red_concrete": "Beton roso",
  "block.minecraft.red_concrete_powder": "Pólvar de beton rosa",
  "block.minecraft.red_glazed_terracotta": "Teracota rosa zmaltà",
  "block.minecraft.red_mushroom": "Fongo roso",
  "block.minecraft.red_mushroom_block": "Bloco de fongo roso",
  "block.minecraft.red_nether_brick_slab": "Łiston de cuarełi rosi de'l Nether",
  "block.minecraft.red_nether_brick_stairs": "Scałe de cuarełi rosi de'l Nether",
  "block.minecraft.red_nether_brick_wall": "Mureta de cuarełi rosi de'l Nether",
  "block.minecraft.red_nether_bricks": "Cuarełi rosi de'l Nether",
  "block.minecraft.red_sand": "Sabia rosa",
  "block.minecraft.red_sandstone": "Arenaria rosa",
  "block.minecraft.red_sandstone_slab": "Łiston de arenaria rosa",
  "block.minecraft.red_sandstone_stairs": "Scałe de arenaria rosa",
  "block.minecraft.red_sandstone_wall": "Mureta de arenaria rosa",
  "block.minecraft.red_shulker_box": "Scàtoła de shulker rosa",
  "block.minecraft.red_stained_glass": "Vero roso",
  "block.minecraft.red_stained_glass_pane": "Panel de vero roso",
  "block.minecraft.red_terracotta": "Teracota rosa",
  "block.minecraft.red_tulip": "Tułipan roso",
  "block.minecraft.red_wool": "Łana rosa",
  "block.minecraft.redstone_block": "Bloco de Redstone",
  "block.minecraft.redstone_lamp": "Lànpada redstone",
  "block.minecraft.redstone_ore": "Mineral de Redstone",
  "block.minecraft.redstone_torch": "Torsa de Redstone",
  "block.minecraft.redstone_wall_torch": "Torsa de Redstone a muro",
  "block.minecraft.redstone_wire": "Cao de Redstone",
  "block.minecraft.reinforced_deepslate": "Fondardesia Rinforsà",
  "block.minecraft.repeater": "Repetidor de redstone",
  "block.minecraft.repeating_command_block": "Bloco comando a repetision",
  "block.minecraft.resin_block": "Bloco de caràsa",
  "block.minecraft.resin_brick_slab": "Liston de cuarèi de Rasa",
  "block.minecraft.resin_brick_stairs": "Scala de cuarèi de Rasa",
  "block.minecraft.resin_brick_wall": "Mureta de cuarèi de Rasa",
  "block.minecraft.resin_bricks": "Cuarèi de Rasa",
  "block.minecraft.resin_clump": "Gropo de caràsa",
  "block.minecraft.respawn_anchor": "Àncora de respawn",
  "block.minecraft.rooted_dirt": "Tera inraisada",
  "block.minecraft.rose_bush": "Rozar",
  "block.minecraft.sand": "Sabia",
  "block.minecraft.sandstone": "Arenaria",
  "block.minecraft.sandstone_slab": "Łiston de arenaria",
  "block.minecraft.sandstone_stairs": "Scałe de arenaria",
  "block.minecraft.sandstone_wall": "Mureta de arenaria",
  "block.minecraft.scaffolding": "Inpalcadura",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizador de sculk",
  "block.minecraft.sculk_sensor": "Sensor de sculk",
  "block.minecraft.sculk_shrieker": "Sbrajador sculk",
  "block.minecraft.sculk_vein": "Vena de Sculk",
  "block.minecraft.sea_lantern": "Łanterna de'l mar",
  "block.minecraft.sea_pickle": "Serùmoło de mar",
  "block.minecraft.seagrass": "Erba acuàdega",
  "block.minecraft.set_spawn": "Ponto de re-spawn inpostà",
  "block.minecraft.short_dry_grass": "Erba seca curta",
  "block.minecraft.short_grass": "Erba curta",
  "block.minecraft.shroomlight": "Sluxifongo",
  "block.minecraft.shulker_box": "Scàtoła de shulker",
  "block.minecraft.skeleton_skull": "Tescio de schèłetro",
  "block.minecraft.skeleton_wall_skull": "Tescio de schèłetro a parede",
  "block.minecraft.slime_block": "Bloco de zeładina",
  "block.minecraft.small_amethyst_bud": "Bòcolo de ametista picenin",
  "block.minecraft.small_dripleaf": "Fojogiossa picenina",
  "block.minecraft.smithing_table": "Banco de'l ferar",
  "block.minecraft.smoker": "Fumegador",
  "block.minecraft.smooth_basalt": "Basalto Slisso",
  "block.minecraft.smooth_quartz": "Bloco de Cuarso Lustro",
  "block.minecraft.smooth_quartz_slab": "Liston de Cuarso Lustro",
  "block.minecraft.smooth_quartz_stairs": "Scale de Cuarso Lustro",
  "block.minecraft.smooth_red_sandstone": "Arenaria rosa łustra",
  "block.minecraft.smooth_red_sandstone_slab": "Łiston de arenaria rosa łustra",
  "block.minecraft.smooth_red_sandstone_stairs": "Scałe de arenaria rosa łustra",
  "block.minecraft.smooth_sandstone": "Arenaria łustra",
  "block.minecraft.smooth_sandstone_slab": "Łiston de arenaria łustra",
  "block.minecraft.smooth_sandstone_stairs": "Scałe de arenaria łustra",
  "block.minecraft.smooth_stone": "Piera łustra",
  "block.minecraft.smooth_stone_slab": "Łiston de piera łustra",
  "block.minecraft.sniffer_egg": "Ovo de snasador",
  "block.minecraft.snow": "Neve",
  "block.minecraft.snow_block": "Bloco de neve",
  "block.minecraft.soul_campfire": "Fogo da canpo de le àneme",
  "block.minecraft.soul_fire": "Fogo de le àneme",
  "block.minecraft.soul_lantern": "Canfìn de le àneme",
  "block.minecraft.soul_sand": "Sabia de łe àneme",
  "block.minecraft.soul_soil": "Tera de le àneme",
  "block.minecraft.soul_torch": "Torsa de le àneme",
  "block.minecraft.soul_wall_torch": "Torsa de le àneme a muro",
  "block.minecraft.spawn.not_valid": "Te ghè nissùn leto o àncora de respawn cargada, o i jera stropà",
  "block.minecraft.spawner": "Zenerador de mostri",
  "block.minecraft.spawner.desc1": "Interazissi co' un Ovo Zenerador:",
  "block.minecraft.spawner.desc2": "Inposta un tipo de Mob",
  "block.minecraft.sponge": "Sponga",
  "block.minecraft.spore_blossom": "Bòcoło de spore",
  "block.minecraft.spruce_button": "Boton de avede",
  "block.minecraft.spruce_door": "Porta de avede",
  "block.minecraft.spruce_fence": "Ringhiera de avede",
  "block.minecraft.spruce_fence_gate": "Sarajo de avede",
  "block.minecraft.spruce_hanging_sign": "Cartel de avede picà",
  "block.minecraft.spruce_leaves": "Foje de avede",
  "block.minecraft.spruce_log": "Fusto de avede",
  "block.minecraft.spruce_planks": "Ase de avede",
  "block.minecraft.spruce_pressure_plate": "Pedana a presion de avede",
  "block.minecraft.spruce_sapling": "Albareło de avede",
  "block.minecraft.spruce_shelf": "Scansìa de Avede",
  "block.minecraft.spruce_sign": "Cartel de avede",
  "block.minecraft.spruce_slab": "Łiston de avede",
  "block.minecraft.spruce_stairs": "Scałe de avede",
  "block.minecraft.spruce_trapdoor": "Rebalta de avede",
  "block.minecraft.spruce_wall_hanging_sign": "Cartel de avede picà a parede",
  "block.minecraft.spruce_wall_sign": "Cartel de avede a parede",
  "block.minecraft.spruce_wood": "Łenjo de avede",
  "block.minecraft.sticky_piston": "Piston tacaiso",
  "block.minecraft.stone": "Piera",
  "block.minecraft.stone_brick_slab": "Łiston de cuarełi de piera",
  "block.minecraft.stone_brick_stairs": "Scałe de cuarełi de piera",
  "block.minecraft.stone_brick_wall": "Mureta de cuarełi de piera",
  "block.minecraft.stone_bricks": "Cuarełi de piera",
  "block.minecraft.stone_button": "Boton de piera",
  "block.minecraft.stone_pressure_plate": "Pedana a presion de piera",
  "block.minecraft.stone_slab": "Łiston de piera",
  "block.minecraft.stone_stairs": "Scałe de piera",
  "block.minecraft.stonecutter": "Tajapiere",
  "block.minecraft.stripped_acacia_log": "Fusto de acasia descorsà",
  "block.minecraft.stripped_acacia_wood": "Łenjo de acasia descorsà",
  "block.minecraft.stripped_bamboo_block": "Bloco de canavera descorsà",
  "block.minecraft.stripped_birch_log": "Fusto de brédoła descorsà",
  "block.minecraft.stripped_birch_wood": "Łenjo de brédoła descorsà",
  "block.minecraft.stripped_cherry_log": "Fusto de çiresar descorsà",
  "block.minecraft.stripped_cherry_wood": "Legno de çiresar descorsà",
  "block.minecraft.stripped_crimson_hyphae": "Ife crèmese descortegàe",
  "block.minecraft.stripped_crimson_stem": "Ganbo crèmese descortegà",
  "block.minecraft.stripped_dark_oak_log": "Fusto de ròvare scura descorsà",
  "block.minecraft.stripped_dark_oak_wood": "Łenjo de ròvare scura descorsà",
  "block.minecraft.stripped_jungle_log": "Fusto de ła jungla descorsà",
  "block.minecraft.stripped_jungle_wood": "Łenjo de ła jungla descorsà",
  "block.minecraft.stripped_mangrove_log": "Fusto de Mangrovia descorsà",
  "block.minecraft.stripped_mangrove_wood": "Łegno de Mangrovia descorsà",
  "block.minecraft.stripped_oak_log": "Fusto de ròvare descorsà",
  "block.minecraft.stripped_oak_wood": "Lenjo de ròvare descorsà",
  "block.minecraft.stripped_pale_oak_log": "Fusto de ròvare ciara descorsà",
  "block.minecraft.stripped_pale_oak_wood": "Łenjo de ròvare ciara descorsà",
  "block.minecraft.stripped_spruce_log": "Fusto de avede descorsà",
  "block.minecraft.stripped_spruce_wood": "Łenjo de avede descorsà",
  "block.minecraft.stripped_warped_hyphae": "Ife strùpie descortegàe",
  "block.minecraft.stripped_warped_stem": "Ganbo strùpio descortegà",
  "block.minecraft.structure_block": "Bloco strutura",
  "block.minecraft.structure_void": "Vudo de ła strutura",
  "block.minecraft.sugar_cane": "Cana da sùcaro",
  "block.minecraft.sunflower": "Zirasol",
  "block.minecraft.suspicious_gravel": "Giara sospeta",
  "block.minecraft.suspicious_sand": "Sabia sospeta",
  "block.minecraft.sweet_berry_bush": "Giavasco de pomełe dolse",
  "block.minecraft.tall_dry_grass": "Erba seca elta",
  "block.minecraft.tall_grass": "Erba elta",
  "block.minecraft.tall_seagrass": "Erba acuàdega alta",
  "block.minecraft.target": "Bersajo",
  "block.minecraft.terracotta": "Teracota",
  "block.minecraft.test_block": "Bloco Test",
  "block.minecraft.test_instance_block": "Bloco istansa de test",
  "block.minecraft.tinted_glass": "Vero scurìo",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "L'esplozión de TNT łe ze dezativàe",
  "block.minecraft.torch": "Torsa",
  "block.minecraft.torchflower": "Luxoflora",
  "block.minecraft.torchflower_crop": "Pianta de luxoflora",
  "block.minecraft.trapped_chest": "Baùl tràpoła",
  "block.minecraft.trial_spawner": "Zenerador de sfide",
  "block.minecraft.tripwire": "Fiło",
  "block.minecraft.tripwire_hook": "Ingancio par fiło",
  "block.minecraft.tube_coral": "Coral a tubo",
  "block.minecraft.tube_coral_block": "Bloco de coral a tubo",
  "block.minecraft.tube_coral_fan": "Gorgonia a tubo",
  "block.minecraft.tube_coral_wall_fan": "Gorgonia a tubo a parede",
  "block.minecraft.tuff": "Tufo",
  "block.minecraft.tuff_brick_slab": "Liston de Cuarèi de Tufo",
  "block.minecraft.tuff_brick_stairs": "Scale de Cuarèi de Tufo",
  "block.minecraft.tuff_brick_wall": "Mureta de Cuarèi de Tufo",
  "block.minecraft.tuff_bricks": "Cuarèi de Tufo",
  "block.minecraft.tuff_slab": "Liston de Tufo",
  "block.minecraft.tuff_stairs": "Scale de Tufo",
  "block.minecraft.tuff_wall": "Mureta de Tufo",
  "block.minecraft.turtle_egg": "Ovo de tartaruga",
  "block.minecraft.twisting_vines": "Ranpeganti intorcolài",
  "block.minecraft.twisting_vines_plant": "Fusto de ranpeganti intocrcolài",
  "block.minecraft.vault": "Cassaforte",
  "block.minecraft.verdant_froglight": "Lumerana Verda",
  "block.minecraft.vine": "Ranpeganti",
  "block.minecraft.void_air": "Aria de'l Vodo",
  "block.minecraft.wall_torch": "Torsa a muro",
  "block.minecraft.warped_button": "Boton strùpio",
  "block.minecraft.warped_door": "Porta strùpia",
  "block.minecraft.warped_fence": "Ringhiera strùpia",
  "block.minecraft.warped_fence_gate": "Sarajo strùpio",
  "block.minecraft.warped_fungus": "Fongo strùpio",
  "block.minecraft.warped_hanging_sign": "Cartel strùpio picà",
  "block.minecraft.warped_hyphae": "Ife strùpie",
  "block.minecraft.warped_nylium": "Neçelio strùpio",
  "block.minecraft.warped_planks": "Asse strùpie",
  "block.minecraft.warped_pressure_plate": "Pedana a pression strùpia",
  "block.minecraft.warped_roots": "Raixe strùpie",
  "block.minecraft.warped_shelf": "Scansìa Deforme",
  "block.minecraft.warped_sign": "Cartelo strùpio",
  "block.minecraft.warped_slab": "Liston strùpio",
  "block.minecraft.warped_stairs": "Scale strùpie",
  "block.minecraft.warped_stem": "Ganbo strùpio",
  "block.minecraft.warped_trapdoor": "Rebalta strùpia",
  "block.minecraft.warped_wall_hanging_sign": "Cartel strùpio picà a parede",
  "block.minecraft.warped_wall_sign": "Cartelo strùpio a parede",
  "block.minecraft.warped_wart_block": "Bloco de pori strùpi",
  "block.minecraft.water": "Acua",
  "block.minecraft.water_cauldron": "Calderon de àcua",
  "block.minecraft.waxed_chiseled_copper": "Ramo Laorà Inçerà",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Bloco de Ramo Inçerà",
  "block.minecraft.waxed_copper_bulb": "Lampada de ramo incerà",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Porta de ramo incerà",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Grada de ramo incerà",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Rebalta de Rame Incerà",
  "block.minecraft.waxed_cut_copper": "Ramo Intajà Inçerà",
  "block.minecraft.waxed_cut_copper_slab": "Liston de Ramo Intajà Inçerà",
  "block.minecraft.waxed_cut_copper_stairs": "Scale de Ramo Intajà Inçerà",
  "block.minecraft.waxed_exposed_chiseled_copper": "Ramo Esponùo Laorà Inçerà",
  "block.minecraft.waxed_exposed_copper": "Ramo Esponùo Inçerà",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Lampada de Ramo Esponùo Intajà Inçerà",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Porta de Ramo Esponùo Intajà Inçerà",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Grada de Ramo Esponùo Intajà Inçerà",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Rebalta de Ramo Esponùo Intajà Inçerà",
  "block.minecraft.waxed_exposed_cut_copper": "Ramo Esponùo Intajà Inçerà",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Liston de Ramo Esponùo Intajà Inçerà",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Scale de Ramo Esponùo Intajà Inçerà",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Ramo Ossidà Laorà Inçerà",
  "block.minecraft.waxed_oxidized_copper": "Ramo Ossidà Inçerà",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lampada de Ramo Ossidà Intajà Inçerà",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Porta de Ramo Ossidà Intajà Inçerà",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Grada de Ramo Ossidà Intajà Inçerà",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Rebalta de Ramo Ossidà Intajà Inçerà",
  "block.minecraft.waxed_oxidized_cut_copper": "Ramo Ossidà Intajà Inçerà",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Liston de Ramo Ossidà Intajà Inçerà",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Scale de Ramo Ossidà Intajà Inçerà",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Ramo Smagnà Laorà Inçerà",
  "block.minecraft.waxed_weathered_copper": "Ramo Smagnà Inçerà",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Lampada de Ramo Smagnà Inçerà",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Porta de Ramo Smagnà Inçerà",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Grada de Ramo Smagnà Inçerà",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Rebalta de Ramo Smagnà Inçerà",
  "block.minecraft.waxed_weathered_cut_copper": "Ramo Smagnà Intajà Inçerà",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Liston de Ramo Smagnà Intajà Inçerà",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Scale de Ramo Smagnà Intajà Inçerà",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Ramo Smagnà Laorà",
  "block.minecraft.weathered_copper": "Ramo Smagnà",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Lampada de Ramo Smagnà",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Porta de Ramo Smagnà",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Grada de Ramo Smagnà",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Rebalta de Ramo Smagnà",
  "block.minecraft.weathered_cut_copper": "Ramo Intajà Smagnà",
  "block.minecraft.weathered_cut_copper_slab": "Liston de Ramo Intajà Smagnà",
  "block.minecraft.weathered_cut_copper_stairs": "Scale de Ramo Intajà Smagnà",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Ranpeganti pianzenti",
  "block.minecraft.weeping_vines_plant": "Fusto de ranpeganti pianzenti",
  "block.minecraft.wet_sponge": "Sponga moja",
  "block.minecraft.wheat": "Coltivasion de formento",
  "block.minecraft.white_banner": "Gonfałon bianco",
  "block.minecraft.white_bed": "Łeto bianco",
  "block.minecraft.white_candle": "Candela bianca",
  "block.minecraft.white_candle_cake": "Torta co' candela bianca",
  "block.minecraft.white_carpet": "Tapéo bianco",
  "block.minecraft.white_concrete": "Beton bianco",
  "block.minecraft.white_concrete_powder": "Pólvar de beton bianca",
  "block.minecraft.white_glazed_terracotta": "Teracota bianca zmaltà",
  "block.minecraft.white_shulker_box": "Scàtoła de shulker bianca",
  "block.minecraft.white_stained_glass": "Vero bianco",
  "block.minecraft.white_stained_glass_pane": "Panel de vero bianco",
  "block.minecraft.white_terracotta": "Teracota bianca",
  "block.minecraft.white_tulip": "Tułipan bianco",
  "block.minecraft.white_wool": "Łana bianca",
  "block.minecraft.wildflowers": "Fiore de canpo",
  "block.minecraft.wither_rose": "Roza de Wither",
  "block.minecraft.wither_skeleton_skull": "Tescio de schèłetro wither",
  "block.minecraft.wither_skeleton_wall_skull": "Tescio de schèłetro wither a parede",
  "block.minecraft.yellow_banner": "Gonfałon zało",
  "block.minecraft.yellow_bed": "Łeto zało",
  "block.minecraft.yellow_candle": "Candela zala",
  "block.minecraft.yellow_candle_cake": "Torta co' candela zala",
  "block.minecraft.yellow_carpet": "Tapéo zało",
  "block.minecraft.yellow_concrete": "Beton zało",
  "block.minecraft.yellow_concrete_powder": "Pólvar de beton zała",
  "block.minecraft.yellow_glazed_terracotta": "Teracota zała zmaltà",
  "block.minecraft.yellow_shulker_box": "Scàtoła de shulker zała",
  "block.minecraft.yellow_stained_glass": "Vero zało",
  "block.minecraft.yellow_stained_glass_pane": "Panel de vero zało",
  "block.minecraft.yellow_terracotta": "Teracota zała",
  "block.minecraft.yellow_wool": "Łana zała",
  "block.minecraft.zombie_head": "Testa de zonbi",
  "block.minecraft.zombie_wall_head": "Testa de zonbi a parede",
  "item.minecraft.acacia_boat": "Barca de acasia",
  "item.minecraft.acacia_chest_boat": "Barca de Acasia co Baul",
  "item.minecraft.allay_spawn_egg": "Ovo zenerador de Allay",
  "item.minecraft.amethyst_shard": "Scheza de ametista",
  "item.minecraft.angler_pottery_shard": "Cocio co cana da pesca",
  "item.minecraft.angler_pottery_sherd": "Cocio co cana da pesca",
  "item.minecraft.apple": "Pomo",
  "item.minecraft.archer_pottery_shard": "Cocio co arco e frecia",
  "item.minecraft.archer_pottery_sherd": "Cocio co arco e frecia",
  "item.minecraft.armadillo_scute": "Scuama de armadilo",
  "item.minecraft.armadillo_spawn_egg": "Ovo zenerador de armadilo",
  "item.minecraft.armor_stand": "Suporto par armadura",
  "item.minecraft.arms_up_pottery_shard": "Cocio co alzada de brazi",
  "item.minecraft.arms_up_pottery_sherd": "Cocio co alzada de brazi",
  "item.minecraft.arrow": "Fresa",
  "item.minecraft.axolotl_bucket": "Secio con axolotl",
  "item.minecraft.axolotl_spawn_egg": "Ovo zenerador de axolotl",
  "item.minecraft.baked_potato": "Patata a'l forno",
  "item.minecraft.bamboo_chest_raft": "Zàtara de canavera con baul",
  "item.minecraft.bamboo_raft": "Zàtara de canavera",
  "item.minecraft.bat_spawn_egg": "Ovo zenerador de barbastreło",
  "item.minecraft.bee_spawn_egg": "Ovo zenerador de ava",
  "item.minecraft.beef": "Manzo crùo",
  "item.minecraft.beetroot": "Rava",
  "item.minecraft.beetroot_seeds": "Somensa de rava",
  "item.minecraft.beetroot_soup": "Supa de rava",
  "item.minecraft.birch_boat": "Barca de brédoła",
  "item.minecraft.birch_chest_boat": "Barca de Bredola co Baul",
  "item.minecraft.black_bundle": "Sachéto negro",
  "item.minecraft.black_dye": "Cołorante negro",
  "item.minecraft.black_harness": "Inbragadura negra",
  "item.minecraft.blade_pottery_shard": "Cocio co łama",
  "item.minecraft.blade_pottery_sherd": "Cocio co łama",
  "item.minecraft.blaze_powder": "Pólvar de blaze",
  "item.minecraft.blaze_rod": "Verga de blaze",
  "item.minecraft.blaze_spawn_egg": "Ovo zenerador de blaze",
  "item.minecraft.blue_bundle": "Sachéto blé",
  "item.minecraft.blue_dye": "Cołorante blè",
  "item.minecraft.blue_egg": "Ovo blé",
  "item.minecraft.blue_harness": "Inbragadura blé",
  "item.minecraft.bogged_spawn_egg": "Ovo zenarador de Paludà",
  "item.minecraft.bolt_armor_trim_smithing_template": "Schema de forgiatura",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ornamento d'armadura Bolon",
  "item.minecraft.bone": "Oso",
  "item.minecraft.bone_meal": "Farina de osi",
  "item.minecraft.book": "Łibro",
  "item.minecraft.bordure_indented_banner_pattern": "Figura par gonfalòn con bordadura dentà",
  "item.minecraft.bow": "Arco",
  "item.minecraft.bowl": "Scudeła",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Verga de breeze",
  "item.minecraft.breeze_spawn_egg": "Ovo zenerador de breeze",
  "item.minecraft.brewer_pottery_shard": "Cocio del vinàro",
  "item.minecraft.brewer_pottery_sherd": "Cocio del vinàro",
  "item.minecraft.brewing_stand": "Łanbico",
  "item.minecraft.brick": "Cuarel",
  "item.minecraft.brown_bundle": "Sachéto maron",
  "item.minecraft.brown_dye": "Cołorante maron",
  "item.minecraft.brown_egg": "Ovo maron",
  "item.minecraft.brown_harness": "Inbragadura maron",
  "item.minecraft.brush": "Bruschin",
  "item.minecraft.bucket": "Secio",
  "item.minecraft.bundle": "Sachéto",
  "item.minecraft.bundle.empty": "Vudo",
  "item.minecraft.bundle.empty.description": "Po' tegnere na piła mista de roba",
  "item.minecraft.bundle.full": "Pien",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Cocio con fiameła",
  "item.minecraft.burn_pottery_sherd": "Cocio con fiameła",
  "item.minecraft.camel_husk_spawn_egg": "Ovo zenerador de Camel Seco",
  "item.minecraft.camel_spawn_egg": "Ovo zenerador de Camel",
  "item.minecraft.carrot": "Carota",
  "item.minecraft.carrot_on_a_stick": "Carota su baston",
  "item.minecraft.cat_spawn_egg": "Ovo zenerador de gato",
  "item.minecraft.cauldron": "Calderon",
  "item.minecraft.cave_spider_spawn_egg": "Ovo zenerador de ragno de le grote",
  "item.minecraft.chainmail_boots": "Stivałi de maja",
  "item.minecraft.chainmail_chestplate": "Corasa de maja",
  "item.minecraft.chainmail_helmet": "Cełada de maja",
  "item.minecraft.chainmail_leggings": "Braghe de maja",
  "item.minecraft.charcoal": "Carboneła",
  "item.minecraft.cherry_boat": "Barca de çiresar",
  "item.minecraft.cherry_chest_boat": "Barca de çiresar co' Baul",
  "item.minecraft.chest_minecart": "Carel co' baùl",
  "item.minecraft.chicken": "Połastro crùo",
  "item.minecraft.chicken_spawn_egg": "Ovo zenerador de polastro",
  "item.minecraft.chorus_fruit": "Fruto de chorus",
  "item.minecraft.clay_ball": "Bala de Crea",
  "item.minecraft.clock": "Rełojo",
  "item.minecraft.coal": "Carbon",
  "item.minecraft.coast_armor_trim_smithing_template": "Schema de forgiatura",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ornamento d'armadura Costera",
  "item.minecraft.cocoa_beans": "Fave de cacào",
  "item.minecraft.cod": "Merluso crùo",
  "item.minecraft.cod_bucket": "Secio con merluso",
  "item.minecraft.cod_spawn_egg": "Ovo zenerador de merlusso",
  "item.minecraft.command_block_minecart": "Carel co' bloco comando",
  "item.minecraft.compass": "Bùsoła",
  "item.minecraft.cooked_beef": "Bisteca",
  "item.minecraft.cooked_chicken": "Połastro cozesto",
  "item.minecraft.cooked_cod": "Merluso cozesto",
  "item.minecraft.cooked_mutton": "Carne de piégora cozesta",
  "item.minecraft.cooked_porkchop": "Brizoła de porsel cozesta",
  "item.minecraft.cooked_rabbit": "Conejo cozesto",
  "item.minecraft.cooked_salmon": "Salmon cozesto",
  "item.minecraft.cookie": "Biscoto",
  "item.minecraft.copper_axe": "Manara de Rame",
  "item.minecraft.copper_boots": "Stivài de Rame",
  "item.minecraft.copper_chestplate": "Corassa de Rame",
  "item.minecraft.copper_golem_spawn_egg": "Ovo zenerador de Golem de Rame",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Sapa de Rame",
  "item.minecraft.copper_horse_armor": "Bardadura de Rame",
  "item.minecraft.copper_ingot": "Lingoto de Ramo",
  "item.minecraft.copper_leggings": "Braghe de Rame",
  "item.minecraft.copper_nautilus_armor": "Armadura de Rame par Nautilo",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Picon de Rame",
  "item.minecraft.copper_shovel": "Baìl de Rame",
  "item.minecraft.copper_spear": "Lança de Rame",
  "item.minecraft.copper_sword": "Spada de Rame",
  "item.minecraft.cow_spawn_egg": "Ovo zenerador de vaca",
  "item.minecraft.creaking_spawn_egg": "Ovo zenerador de Scrico",
  "item.minecraft.creeper_banner_pattern": "Fegura par gonfałon",
  "item.minecraft.creeper_banner_pattern.desc": "Stanpa de creeper",
  "item.minecraft.creeper_banner_pattern.new": "Figura par gonfalòn con creeper",
  "item.minecraft.creeper_spawn_egg": "Ovo zenerador de creeper",
  "item.minecraft.crossbow": "Bałestra",
  "item.minecraft.crossbow.projectile": "Projètiłe:",
  "item.minecraft.crossbow.projectile.multiple": "Projètile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projètile: %s",
  "item.minecraft.cyan_bundle": "Sachéto ciano",
  "item.minecraft.cyan_dye": "Cołorante sian",
  "item.minecraft.cyan_harness": "Inbragadura çian",
  "item.minecraft.danger_pottery_shard": "Cocio con avertimento",
  "item.minecraft.danger_pottery_sherd": "Cocio con avertimento",
  "item.minecraft.dark_oak_boat": "Barca de ròvare scura",
  "item.minecraft.dark_oak_chest_boat": "Barca de Rovare scura co Baul",
  "item.minecraft.debug_stick": "Baston de debug",
  "item.minecraft.debug_stick.empty": "%s no'l ga propietà",
  "item.minecraft.debug_stick.select": "sełesionà \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" canbià in %s",
  "item.minecraft.diamond": "Diamante",
  "item.minecraft.diamond_axe": "Manara de Diamante",
  "item.minecraft.diamond_boots": "Stivài de Diamante",
  "item.minecraft.diamond_chestplate": "Corassa de Diamante",
  "item.minecraft.diamond_helmet": "Çelada de Diamante",
  "item.minecraft.diamond_hoe": "Sapa de Diamante",
  "item.minecraft.diamond_horse_armor": "Bardadura de Diamante",
  "item.minecraft.diamond_leggings": "Braghe de Diamante",
  "item.minecraft.diamond_nautilus_armor": "Armadura de Brilante par Nautilo",
  "item.minecraft.diamond_pickaxe": "Picon de Diamante",
  "item.minecraft.diamond_shovel": "Baìl de Diamante",
  "item.minecraft.diamond_spear": "Lança de Brilante",
  "item.minecraft.diamond_sword": "Spada de Diamante",
  "item.minecraft.disc_fragment_5": "Framento de Disco",
  "item.minecraft.disc_fragment_5.desc": "Disco muzical - 5",
  "item.minecraft.dolphin_spawn_egg": "Ovo zenerador de dolfin",
  "item.minecraft.donkey_spawn_egg": "Ovo zenerador de àseno",
  "item.minecraft.dragon_breath": "Supio de dragon",
  "item.minecraft.dried_kelp": "Àlega seca",
  "item.minecraft.drowned_spawn_egg": "Ovo zenerador de negà",
  "item.minecraft.dune_armor_trim_smithing_template": "Schema de forgiatura",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ornamento d'armadura Duna",
  "item.minecraft.echo_shard": "Scheja de'l Eco",
  "item.minecraft.egg": "Ovo",
  "item.minecraft.elder_guardian_spawn_egg": "Ovo zenerador de guardian antigo",
  "item.minecraft.elytra": "Elytre",
  "item.minecraft.emerald": "Smeraldo",
  "item.minecraft.enchanted_book": "Łibro incantà",
  "item.minecraft.enchanted_golden_apple": "Pomo indorà incantà",
  "item.minecraft.end_crystal": "Cristal de'l End",
  "item.minecraft.ender_dragon_spawn_egg": "Ovo zenerador de Dragon del End",
  "item.minecraft.ender_eye": "Ocio de ender",
  "item.minecraft.ender_pearl": "Perla de ender",
  "item.minecraft.enderman_spawn_egg": "Ovo zenerador de enderman",
  "item.minecraft.endermite_spawn_egg": "Ovo zenerador de endermite",
  "item.minecraft.evoker_spawn_egg": "Ovo zenerador de evocador",
  "item.minecraft.experience_bottle": "Anpoła de espariensa",
  "item.minecraft.explorer_pottery_shard": "Cocio con mapa",
  "item.minecraft.explorer_pottery_sherd": "Cocio con mapa",
  "item.minecraft.eye_armor_trim_smithing_template": "Schema de forgiatura",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ornamento d'armadura Ocio",
  "item.minecraft.feather": "Pena",
  "item.minecraft.fermented_spider_eye": "Ocio de ranjo farmentà",
  "item.minecraft.field_masoned_banner_pattern": "Figura par gonfalòn de matoni",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Carga de fogo",
  "item.minecraft.firework_rocket": "Rocheta pirotècnega",
  "item.minecraft.firework_rocket.flight": "Durada de voło:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Steła pirotècnega",
  "item.minecraft.firework_star.black": "Negro",
  "item.minecraft.firework_star.blue": "Blè",
  "item.minecraft.firework_star.brown": "Maron",
  "item.minecraft.firework_star.custom_color": "Parsonałizà",
  "item.minecraft.firework_star.cyan": "Sian",
  "item.minecraft.firework_star.fade_to": "Sfuma in",
  "item.minecraft.firework_star.flicker": "Złuzeghin",
  "item.minecraft.firework_star.gray": "Grizo",
  "item.minecraft.firework_star.green": "Verdo",
  "item.minecraft.firework_star.light_blue": "Sełeste",
  "item.minecraft.firework_star.light_gray": "Grizo ciaro",
  "item.minecraft.firework_star.lime": "Lime",
  "item.minecraft.firework_star.magenta": "Mazenta",
  "item.minecraft.firework_star.orange": "Naransa",
  "item.minecraft.firework_star.pink": "Roza",
  "item.minecraft.firework_star.purple": "Vioła",
  "item.minecraft.firework_star.red": "Roso",
  "item.minecraft.firework_star.shape": "Forma mìa conosesta",
  "item.minecraft.firework_star.shape.burst": "Sciopo",
  "item.minecraft.firework_star.shape.creeper": "A forma de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bała granda",
  "item.minecraft.firework_star.shape.small_ball": "Bała pìcoła",
  "item.minecraft.firework_star.shape.star": "A forma de steła",
  "item.minecraft.firework_star.trail": "Trasa",
  "item.minecraft.firework_star.white": "Bianco",
  "item.minecraft.firework_star.yellow": "Zało",
  "item.minecraft.fishing_rod": "Cana da pesca",
  "item.minecraft.flint": "Séłeze",
  "item.minecraft.flint_and_steel": "Batifogo",
  "item.minecraft.flow_armor_trim_smithing_template": "Schema de forgiatura",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ornamento d'armadura Corivo",
  "item.minecraft.flow_banner_pattern": "Figura par gonfałon",
  "item.minecraft.flow_banner_pattern.desc": "Fluso",
  "item.minecraft.flow_banner_pattern.new": "Figura par gonfalòn con corìvo",
  "item.minecraft.flow_pottery_sherd": "Cocio con corìvo",
  "item.minecraft.flower_banner_pattern": "Fegura par gonfałon",
  "item.minecraft.flower_banner_pattern.desc": "Stanpa de fior",
  "item.minecraft.flower_banner_pattern.new": "Figura par gonfalòn con fiore",
  "item.minecraft.flower_pot": "Vazo da fiori",
  "item.minecraft.fox_spawn_egg": "Ovo zenerador de volpe",
  "item.minecraft.friend_pottery_shard": "Cocio co amigo",
  "item.minecraft.friend_pottery_sherd": "Cocio co amigo",
  "item.minecraft.frog_spawn_egg": "Ovo zenerador de Rana",
  "item.minecraft.furnace_minecart": "Carel co' fornaze",
  "item.minecraft.ghast_spawn_egg": "Ovo zenerador de ghast",
  "item.minecraft.ghast_tear": "Łàgrema de ghast",
  "item.minecraft.glass_bottle": "Anpoła de vero",
  "item.minecraft.glistering_melon_slice": "Feta de inguria zluzegante",
  "item.minecraft.globe_banner_pattern": "Figura par gonfałon",
  "item.minecraft.globe_banner_pattern.desc": "Globo",
  "item.minecraft.globe_banner_pattern.new": "Figura par gonfalòn con globo",
  "item.minecraft.glow_berries": "Pomele sluxorine",
  "item.minecraft.glow_ink_sac": "Saca de ingiostro luxénte",
  "item.minecraft.glow_item_frame": "Soàxa luxénte",
  "item.minecraft.glow_squid_spawn_egg": "Ovo zenerador de całamar luxénte",
  "item.minecraft.glowstone_dust": "Pólvar de zluzorite",
  "item.minecraft.goat_horn": "Corno de Cavara",
  "item.minecraft.goat_spawn_egg": "Ovo zenerador de càvara",
  "item.minecraft.gold_ingot": "Lingoto de Oro",
  "item.minecraft.gold_nugget": "Pepita de Oro",
  "item.minecraft.golden_apple": "Pomo indorà",
  "item.minecraft.golden_axe": "Manara de Oro",
  "item.minecraft.golden_boots": "Stivài de Oro",
  "item.minecraft.golden_carrot": "Carota indorada",
  "item.minecraft.golden_chestplate": "Corassa de Oro",
  "item.minecraft.golden_helmet": "Çelada de Oro",
  "item.minecraft.golden_hoe": "Sapa de Oro",
  "item.minecraft.golden_horse_armor": "Bardadura de oro",
  "item.minecraft.golden_leggings": "Braghe de Oro",
  "item.minecraft.golden_nautilus_armor": "Armadura de Oro par Nautilo",
  "item.minecraft.golden_pickaxe": "Picon de Oro",
  "item.minecraft.golden_shovel": "Baìl de Oro",
  "item.minecraft.golden_spear": "Lança de Oro",
  "item.minecraft.golden_sword": "Spada de Oro",
  "item.minecraft.gray_bundle": "Sachéto griso",
  "item.minecraft.gray_dye": "Cołorante grizo",
  "item.minecraft.gray_harness": "Inbragadura grisa",
  "item.minecraft.green_bundle": "Sachéto verdo",
  "item.minecraft.green_dye": "Cołorante verdo",
  "item.minecraft.green_harness": "Inbragadura verda",
  "item.minecraft.guardian_spawn_egg": "Ovo zenerador de guardian",
  "item.minecraft.gunpowder": "Pólvar da zbaro",
  "item.minecraft.guster_banner_pattern": "Fegura par gonfałon",
  "item.minecraft.guster_banner_pattern.desc": "Ràfega",
  "item.minecraft.guster_banner_pattern.new": "Figura par gonfalòn con ràfega",
  "item.minecraft.guster_pottery_sherd": "Cocio con ràfega",
  "item.minecraft.happy_ghast_spawn_egg": "Ovo zenerador de Ghast Alegro",
  "item.minecraft.harness": "Inbragadura",
  "item.minecraft.heart_of_the_sea": "Cor de'l mar",
  "item.minecraft.heart_pottery_shard": "Cocio con core",
  "item.minecraft.heart_pottery_sherd": "Cocio con core",
  "item.minecraft.heartbreak_pottery_shard": "Cocio con core roto",
  "item.minecraft.heartbreak_pottery_sherd": "Cocio con core roto",
  "item.minecraft.hoglin_spawn_egg": "Vòvo zenerador de Hoglin",
  "item.minecraft.honey_bottle": "Anpoła de mel",
  "item.minecraft.honeycomb": "Caraza",
  "item.minecraft.hopper_minecart": "Carel co' tramoza",
  "item.minecraft.horse_spawn_egg": "Ovo zenerador de caval",
  "item.minecraft.host_armor_trim_smithing_template": "Schema de forgiatura",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ornamento stiłe ospite",
  "item.minecraft.howl_pottery_shard": "Cocio con ululàto",
  "item.minecraft.howl_pottery_sherd": "Cocio con ululàto",
  "item.minecraft.husk_spawn_egg": "Ovo zenerador de zonbi seco",
  "item.minecraft.ink_sac": "Saca de inciostro",
  "item.minecraft.iron_axe": "Manara de Fero",
  "item.minecraft.iron_boots": "Stivài de Fero",
  "item.minecraft.iron_chestplate": "Corassa de Fero",
  "item.minecraft.iron_golem_spawn_egg": "Ovo zenerador de Golem de Fero",
  "item.minecraft.iron_helmet": "Çelada de Fero",
  "item.minecraft.iron_hoe": "Sapa de Fero",
  "item.minecraft.iron_horse_armor": "Bardadura de Fero",
  "item.minecraft.iron_ingot": "Lingoto de Fero",
  "item.minecraft.iron_leggings": "Braghe de Fero",
  "item.minecraft.iron_nautilus_armor": "Armadura de Fero par Nautilo",
  "item.minecraft.iron_nugget": "Pepita de Fero",
  "item.minecraft.iron_pickaxe": "Picon de Fero",
  "item.minecraft.iron_shovel": "Baìl de Fero",
  "item.minecraft.iron_spear": "Lança de Fero",
  "item.minecraft.iron_sword": "Spada de Fero",
  "item.minecraft.item_frame": "Corniza",
  "item.minecraft.jungle_boat": "Barca de ła jungla",
  "item.minecraft.jungle_chest_boat": "Barca de la Jungla co Baul",
  "item.minecraft.knowledge_book": "Łibro de ła conosensa",
  "item.minecraft.lapis_lazuli": "Lapislàsaro",
  "item.minecraft.lava_bucket": "Secio de lava",
  "item.minecraft.lead": "Zguinsajo",
  "item.minecraft.leather": "Corame",
  "item.minecraft.leather_boots": "Stivałi de corame",
  "item.minecraft.leather_chestplate": "Tùnega de corame",
  "item.minecraft.leather_helmet": "Scufia de corame",
  "item.minecraft.leather_horse_armor": "Bardadura de corame",
  "item.minecraft.leather_leggings": "Braghe de corame",
  "item.minecraft.light_blue_bundle": "Sachéto çeleste",
  "item.minecraft.light_blue_dye": "Cołorante sełeste",
  "item.minecraft.light_blue_harness": "Inbragadura çeleste",
  "item.minecraft.light_gray_bundle": "Sachéto griso ciaro",
  "item.minecraft.light_gray_dye": "Cołorante grizo ciaro",
  "item.minecraft.light_gray_harness": "Inbragadura griso ciaro",
  "item.minecraft.lime_bundle": "Sacheto lime",
  "item.minecraft.lime_dye": "Cołorante lime",
  "item.minecraft.lime_harness": "Inbragadura lime",
  "item.minecraft.lingering_potion": "Posion parsistente",
  "item.minecraft.lingering_potion.effect.awkward": "Posion stranba parsistente",
  "item.minecraft.lingering_potion.effect.empty": "Posion parsistente mìa fabricàbiłe",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Posion parsistente de rezistensa a'l fogo",
  "item.minecraft.lingering_potion.effect.harming": "Posion parsistente de dano",
  "item.minecraft.lingering_potion.effect.healing": "Posion parsistente de cura",
  "item.minecraft.lingering_potion.effect.infested": "Posion parsistente de infestasiòn",
  "item.minecraft.lingering_potion.effect.invisibility": "Posion parsistente de l'invizibiłità",
  "item.minecraft.lingering_potion.effect.leaping": "Posion parsistente de salto",
  "item.minecraft.lingering_potion.effect.levitation": "Posion parsistente de łevitasion",
  "item.minecraft.lingering_potion.effect.luck": "Posion parsistente de fortuna",
  "item.minecraft.lingering_potion.effect.mundane": "Posion ordenaria parsistente",
  "item.minecraft.lingering_potion.effect.night_vision": "Posion parsistente de vista noturna",
  "item.minecraft.lingering_potion.effect.oozing": "Posion parsistente de trasudasiòn",
  "item.minecraft.lingering_potion.effect.poison": "Posion parsistente de vełen",
  "item.minecraft.lingering_potion.effect.regeneration": "Posion parsistente de rezenarasion",
  "item.minecraft.lingering_potion.effect.slow_falling": "Posion parsistente de cascada łenta",
  "item.minecraft.lingering_potion.effect.slowness": "Posion parsistente de łentesa",
  "item.minecraft.lingering_potion.effect.strength": "Posion parsistente de forsa",
  "item.minecraft.lingering_potion.effect.swiftness": "Posion parsistente de sveltesa",
  "item.minecraft.lingering_potion.effect.thick": "Posion fisa parsistente",
  "item.minecraft.lingering_potion.effect.turtle_master": "Posion parsistente de'l maestro tartaruga",
  "item.minecraft.lingering_potion.effect.water": "Anpoła de àcua parsistente",
  "item.minecraft.lingering_potion.effect.water_breathing": "Posion parsitente de respir. acuàtega",
  "item.minecraft.lingering_potion.effect.weakness": "Posion parsistente de fiaca",
  "item.minecraft.lingering_potion.effect.weaving": "Posion parsistente de tesidura",
  "item.minecraft.lingering_potion.effect.wind_charged": "Posion parsistente de carica ventosa",
  "item.minecraft.llama_spawn_egg": "Ovo zenerador de lama",
  "item.minecraft.lodestone_compass": "Bùssola magnetizada",
  "item.minecraft.mace": "Màssa",
  "item.minecraft.magenta_bundle": "Sachéto magenta",
  "item.minecraft.magenta_dye": "Cołorante mazenta",
  "item.minecraft.magenta_harness": "Inbragadura mazenta",
  "item.minecraft.magma_cream": "Crema de magma",
  "item.minecraft.magma_cube_spawn_egg": "Ovo zenerador de cubo de magma",
  "item.minecraft.mangrove_boat": "Barca de Mangrovia",
  "item.minecraft.mangrove_chest_boat": "Barca de Mangrovia co Baul",
  "item.minecraft.map": "Mapa voda",
  "item.minecraft.melon_seeds": "Somensa de inguria",
  "item.minecraft.melon_slice": "Feta de inguria",
  "item.minecraft.milk_bucket": "Secio de łate",
  "item.minecraft.minecart": "Carel da minera",
  "item.minecraft.miner_pottery_shard": "Cocio con pìco",
  "item.minecraft.miner_pottery_sherd": "Cocio con pìco",
  "item.minecraft.mojang_banner_pattern": "Fegura par gonfałon",
  "item.minecraft.mojang_banner_pattern.desc": "Łogo",
  "item.minecraft.mojang_banner_pattern.new": "Figura par gonfalòn con logo",
  "item.minecraft.mooshroom_spawn_egg": "Ovo zenerador de mooshroom",
  "item.minecraft.mourner_pottery_shard": "Cocio con luto",
  "item.minecraft.mourner_pottery_sherd": "Cocio con luto",
  "item.minecraft.mule_spawn_egg": "Ovo zenerador de mulo",
  "item.minecraft.mushroom_stew": "Supa de fongi",
  "item.minecraft.music_disc_11": "Disco muzegal",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disco muzegal",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disco muzegal",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disco muzegal",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disco muzegal",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disco muzegal",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disco muzical",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disco muzical",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (carillon)",
  "item.minecraft.music_disc_far": "Disco muzegal",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disco muzegal",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disco muzegal",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disco muzegal",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disco muzegal",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disco muzical",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disco muzical",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disco muzegal",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disco muzegal",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disco musegal",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy — Tears",
  "item.minecraft.music_disc_wait": "Disco muzegal",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disco muzegal",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Carne de piégora crùa",
  "item.minecraft.name_tag": "Tabel",
  "item.minecraft.nautilus_shell": "Zgusa de nautilus",
  "item.minecraft.nautilus_spawn_egg": "Ovo zenerador de Nautilo",
  "item.minecraft.nether_brick": "Cuarel de'l Nether",
  "item.minecraft.nether_star": "Steła de'l Nether",
  "item.minecraft.nether_wart": "Poro de'l Nether",
  "item.minecraft.netherite_axe": "Manara de Netherite",
  "item.minecraft.netherite_boots": "Stivài de Netherite",
  "item.minecraft.netherite_chestplate": "Corassa de Netherite",
  "item.minecraft.netherite_helmet": "Çelada de Netherite",
  "item.minecraft.netherite_hoe": "Sapa de Netherite",
  "item.minecraft.netherite_horse_armor": "Bardadura de Netherite",
  "item.minecraft.netherite_ingot": "Lingoto de Netherite",
  "item.minecraft.netherite_leggings": "Braghe de Netherite",
  "item.minecraft.netherite_nautilus_armor": "Armadura de Netherite par Nautilo",
  "item.minecraft.netherite_pickaxe": "Picon de Netherite",
  "item.minecraft.netherite_scrap": "Sgresenda de Netherite",
  "item.minecraft.netherite_shovel": "Baìl de Netherite",
  "item.minecraft.netherite_spear": "Lança de Netherite",
  "item.minecraft.netherite_sword": "Spada de Netherite",
  "item.minecraft.netherite_upgrade_smithing_template": "Schema de forgiatura",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Mejorìa de Netherite",
  "item.minecraft.oak_boat": "Barca de ròvare",
  "item.minecraft.oak_chest_boat": "Barca de Rovare co Baul",
  "item.minecraft.ocelot_spawn_egg": "Ovo zenerador de gatopardo",
  "item.minecraft.ominous_bottle": "Botiglia infausta",
  "item.minecraft.ominous_trial_key": "Ciave de ła sfida infausta",
  "item.minecraft.orange_bundle": "Sachéto narànsa",
  "item.minecraft.orange_dye": "Cołorante naransa",
  "item.minecraft.orange_harness": "Inbragadura naranza",
  "item.minecraft.painting": "Cuadro",
  "item.minecraft.pale_oak_boat": "Barca de ròvare pàlido",
  "item.minecraft.pale_oak_chest_boat": "Barca de ròvare pàlida co Baul",
  "item.minecraft.panda_spawn_egg": "Ovo zenerador de panda",
  "item.minecraft.paper": "Fojo",
  "item.minecraft.parched_spawn_egg": "Ovo zenerador de Arsirà",
  "item.minecraft.parrot_spawn_egg": "Ovo zenerador de papagal",
  "item.minecraft.phantom_membrane": "Menbrana de'l phantom",
  "item.minecraft.phantom_spawn_egg": "Ovo zenerador de phantom",
  "item.minecraft.pig_spawn_egg": "Ovo zenerador de porsel",
  "item.minecraft.piglin_banner_pattern": "Fegura par gonfałon",
  "item.minecraft.piglin_banner_pattern.desc": "Grugno",
  "item.minecraft.piglin_banner_pattern.new": "Figura par gonfalòn con muso de mas'cio",
  "item.minecraft.piglin_brute_spawn_egg": "Ovo zenerador de Piglin bruto",
  "item.minecraft.piglin_spawn_egg": "Ovo zenarador de Piglin",
  "item.minecraft.pillager_spawn_egg": "Ovo zenerador de sachejador",
  "item.minecraft.pink_bundle": "Sachéto rosa",
  "item.minecraft.pink_dye": "Cołorante roza",
  "item.minecraft.pink_harness": "Inbragadura rosa",
  "item.minecraft.pitcher_plant": "Pianta carnìvora",
  "item.minecraft.pitcher_pod": "Coltura de pianta carnìvora",
  "item.minecraft.plenty_pottery_shard": "Cocio con schèi",
  "item.minecraft.plenty_pottery_sherd": "Cocio con schèi",
  "item.minecraft.poisonous_potato": "Patata vełenoza",
  "item.minecraft.polar_bear_spawn_egg": "Ovo zenerador de orso polar",
  "item.minecraft.popped_chorus_fruit": "Fruto de chorus sciopà",
  "item.minecraft.porkchop": "Brizoła de porsel crùa",
  "item.minecraft.potato": "Patata",
  "item.minecraft.potion": "Posion",
  "item.minecraft.potion.effect.awkward": "Posion stranba",
  "item.minecraft.potion.effect.empty": "Posion mìa fabricàbiłe",
  "item.minecraft.potion.effect.fire_resistance": "Posion de rezistensa a'l fogo",
  "item.minecraft.potion.effect.harming": "Posion de dano",
  "item.minecraft.potion.effect.healing": "Posion de cura",
  "item.minecraft.potion.effect.infested": "Posion de infestasiòn",
  "item.minecraft.potion.effect.invisibility": "Posion de l'invizibiłità",
  "item.minecraft.potion.effect.leaping": "Posion de salto",
  "item.minecraft.potion.effect.levitation": "Posion de łevitasion",
  "item.minecraft.potion.effect.luck": "Posion de fortuna",
  "item.minecraft.potion.effect.mundane": "Posion ordenaria",
  "item.minecraft.potion.effect.night_vision": "Posion de vista noturna",
  "item.minecraft.potion.effect.oozing": "Posion de trasudasiòn",
  "item.minecraft.potion.effect.poison": "Posion de vełen",
  "item.minecraft.potion.effect.regeneration": "Posion de rezenarasion",
  "item.minecraft.potion.effect.slow_falling": "Posion de cascada łenta",
  "item.minecraft.potion.effect.slowness": "Posion de łentesa",
  "item.minecraft.potion.effect.strength": "Posion de forsa",
  "item.minecraft.potion.effect.swiftness": "Posion de sveltesa",
  "item.minecraft.potion.effect.thick": "Posion fisa",
  "item.minecraft.potion.effect.turtle_master": "Posion de'l maestro tartaruga",
  "item.minecraft.potion.effect.water": "Anpoła de àcua",
  "item.minecraft.potion.effect.water_breathing": "Posion de respir. acuàtega",
  "item.minecraft.potion.effect.weakness": "Posion de fiaca",
  "item.minecraft.potion.effect.weaving": "Posion de tesidura",
  "item.minecraft.potion.effect.wind_charged": "Posion de carga ventosa",
  "item.minecraft.pottery_shard_archer": "Cocio co arco e frecia",
  "item.minecraft.pottery_shard_arms_up": "Cocio co alzada de brazi",
  "item.minecraft.pottery_shard_prize": "Cocio co premio",
  "item.minecraft.pottery_shard_skull": "Scheza con Tescio",
  "item.minecraft.powder_snow_bucket": "Secio de neve polvarosa",
  "item.minecraft.prismarine_crystals": "Cristal de prizmarin",
  "item.minecraft.prismarine_shard": "Scheja de prizmarin",
  "item.minecraft.prize_pottery_shard": "Scheza con Premio",
  "item.minecraft.prize_pottery_sherd": "Scheza con Premio",
  "item.minecraft.pufferfish": "Pese bała",
  "item.minecraft.pufferfish_bucket": "Secio con pese bała",
  "item.minecraft.pufferfish_spawn_egg": "Ovo zenerador de pesse bala",
  "item.minecraft.pumpkin_pie": "Torta de suca",
  "item.minecraft.pumpkin_seeds": "Somensa de suca",
  "item.minecraft.purple_bundle": "Musina viola",
  "item.minecraft.purple_dye": "Cołorante vioła",
  "item.minecraft.purple_harness": "Inbragadura viola",
  "item.minecraft.quartz": "Cuarso del Nether",
  "item.minecraft.rabbit": "Conejo crùo",
  "item.minecraft.rabbit_foot": "Sata de conejo",
  "item.minecraft.rabbit_hide": "Pel de conejo",
  "item.minecraft.rabbit_spawn_egg": "Ovo zenerador de conejo",
  "item.minecraft.rabbit_stew": "Pastisada de conejo",
  "item.minecraft.raiser_armor_trim_smithing_template": "Schema de forzadura",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Ovo zenarador de devastador",
  "item.minecraft.raw_copper": "Ramo Grezo",
  "item.minecraft.raw_gold": "Oro Grezo",
  "item.minecraft.raw_iron": "Fero Grezo",
  "item.minecraft.recovery_compass": "Bùsola de Ritrovo",
  "item.minecraft.red_bundle": "Musina rossa",
  "item.minecraft.red_dye": "Cołorante roso",
  "item.minecraft.red_harness": "Inbragadura rossa",
  "item.minecraft.redstone": "Pólvar de Redstone",
  "item.minecraft.resin_brick": "Cuarel de Rasa",
  "item.minecraft.resin_clump": "Gropo de Rasa",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Carne zmarsa",
  "item.minecraft.saddle": "Seła",
  "item.minecraft.salmon": "Salmon crùo",
  "item.minecraft.salmon_bucket": "Secio con salmon",
  "item.minecraft.salmon_spawn_egg": "Ovo zenerador de salmon",
  "item.minecraft.scrape_pottery_sherd": "Scheza con Sfriso",
  "item.minecraft.scute": "Scuto",
  "item.minecraft.sentry_armor_trim_smithing_template": "Schema de forzadura",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Pottery Sherd",
  "item.minecraft.shears": "Fòrbeze",
  "item.minecraft.sheep_spawn_egg": "Ovo zenerador de pégora",
  "item.minecraft.shelter_pottery_shard": "Shelter Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "Shelter Pottery Sherd",
  "item.minecraft.shield": "Scudo",
  "item.minecraft.shield.black": "Scudo negro",
  "item.minecraft.shield.blue": "Scudo blè",
  "item.minecraft.shield.brown": "Scudo maron",
  "item.minecraft.shield.cyan": "Scudo sian",
  "item.minecraft.shield.gray": "Scudo grizo",
  "item.minecraft.shield.green": "Scudo verdo",
  "item.minecraft.shield.light_blue": "Scudo sełeste",
  "item.minecraft.shield.light_gray": "Scudo grizo ciaro",
  "item.minecraft.shield.lime": "Scudo lime",
  "item.minecraft.shield.magenta": "Scudo mazenta",
  "item.minecraft.shield.orange": "Scudo naransa",
  "item.minecraft.shield.pink": "Scudo roza",
  "item.minecraft.shield.purple": "Scudo vioła",
  "item.minecraft.shield.red": "Scudo roso",
  "item.minecraft.shield.white": "Scudo bianco",
  "item.minecraft.shield.yellow": "Scudo zało",
  "item.minecraft.shulker_shell": "Zgusa de shulker",
  "item.minecraft.shulker_spawn_egg": "Ovo zenerador de shulker",
  "item.minecraft.sign": "Cartel",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Ovo zenerador de pesse arzentà",
  "item.minecraft.skeleton_horse_spawn_egg": "Ovo zenerador de caval schèletro",
  "item.minecraft.skeleton_spawn_egg": "Ovo zenerador de schèletro",
  "item.minecraft.skull_banner_pattern": "Fegura par gonfałon",
  "item.minecraft.skull_banner_pattern.desc": "Stanpa de tescio",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "Skull Pottery Sherd",
  "item.minecraft.slime_ball": "Bała de zeładina",
  "item.minecraft.slime_spawn_egg": "Ovo zenerador de zeladina",
  "item.minecraft.smithing_template": "Schema de forzadura",
  "item.minecraft.smithing_template.applies_to": "El se àplega a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Zonta un lingoto o un cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Zonta un toco de armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingoti e cristài",
  "item.minecraft.smithing_template.ingredients": "Ingredienti:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Zonta un lingoto de netherite",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Echipajamento de brilante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Zonta n'armadura, n'arma o n'arte de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingoto de netherite",
  "item.minecraft.smithing_template.upgrade": "Mejora: ",
  "item.minecraft.sniffer_spawn_egg": "Ovo zenerador de snasador",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Schema de forzadura",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Ovo zenerador de Golem de Neve",
  "item.minecraft.snowball": "Bałoco",
  "item.minecraft.spectral_arrow": "Fresa spetral",
  "item.minecraft.spider_eye": "Ocio de ranjo",
  "item.minecraft.spider_spawn_egg": "Ovo zenerador de ragno",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Posion da tiro",
  "item.minecraft.splash_potion.effect.awkward": "Posion stranba da tiro",
  "item.minecraft.splash_potion.effect.empty": "Posion da tiro mìa fabricàbiłe",
  "item.minecraft.splash_potion.effect.fire_resistance": "Posion da tiro de rezistensa a'l fogo",
  "item.minecraft.splash_potion.effect.harming": "Posion da tiro de dano",
  "item.minecraft.splash_potion.effect.healing": "Posion da tiro de cura",
  "item.minecraft.splash_potion.effect.infested": "Posion da tiro de infestasion",
  "item.minecraft.splash_potion.effect.invisibility": "Posion da tiro de l'invizibiłità",
  "item.minecraft.splash_potion.effect.leaping": "Posion da tiro de salto",
  "item.minecraft.splash_potion.effect.levitation": "Posion da tiro de łevitasion",
  "item.minecraft.splash_potion.effect.luck": "Posion da tiro de fortuna",
  "item.minecraft.splash_potion.effect.mundane": "Posion ordenaria da tiro",
  "item.minecraft.splash_potion.effect.night_vision": "Posion da tiro de vista noturna",
  "item.minecraft.splash_potion.effect.oozing": "Posion da tiro de secresion",
  "item.minecraft.splash_potion.effect.poison": "Posion da tiro de vełen",
  "item.minecraft.splash_potion.effect.regeneration": "Posion da tiro de rezenarasion",
  "item.minecraft.splash_potion.effect.slow_falling": "Posion da tiro de cascada łenta",
  "item.minecraft.splash_potion.effect.slowness": "Posion da tiro de łentesa",
  "item.minecraft.splash_potion.effect.strength": "Posion da tiro de forsa",
  "item.minecraft.splash_potion.effect.swiftness": "Posion da tiro de sveltesa",
  "item.minecraft.splash_potion.effect.thick": "Posion fisa da tiro",
  "item.minecraft.splash_potion.effect.turtle_master": "Posion da tiro de'l maestro tartaruga",
  "item.minecraft.splash_potion.effect.water": "Anpoła d'àcua da tiro",
  "item.minecraft.splash_potion.effect.water_breathing": "Posion da tiro de respir. acuàtega",
  "item.minecraft.splash_potion.effect.weakness": "Posion da tiro de fiaca",
  "item.minecraft.splash_potion.effect.weaving": "Posion da tiro de tessidura",
  "item.minecraft.splash_potion.effect.wind_charged": "Posion da tiro de carga de vento",
  "item.minecraft.spruce_boat": "Barca de avede",
  "item.minecraft.spruce_chest_boat": "Barca de Avede co Baul",
  "item.minecraft.spyglass": "Canocial",
  "item.minecraft.squid_spawn_egg": "Ovo zenerador de calamaro",
  "item.minecraft.stick": "Baston",
  "item.minecraft.stone_axe": "Manara de piera",
  "item.minecraft.stone_hoe": "Sapa de piera",
  "item.minecraft.stone_pickaxe": "Picon de piera",
  "item.minecraft.stone_shovel": "Baìl de piera",
  "item.minecraft.stone_spear": "Lança de Piera",
  "item.minecraft.stone_sword": "Spada de piera",
  "item.minecraft.stray_spawn_egg": "Ovo zenerador de viandante",
  "item.minecraft.strider_spawn_egg": "Ovo zenerador de caminador",
  "item.minecraft.string": "Soga",
  "item.minecraft.sugar": "Sùcaro",
  "item.minecraft.suspicious_stew": "Supa sospeta",
  "item.minecraft.sweet_berries": "Pomełe dolse",
  "item.minecraft.tadpole_bucket": "Secio con Girin",
  "item.minecraft.tadpole_spawn_egg": "Ovo zenerador de Girin",
  "item.minecraft.tide_armor_trim_smithing_template": "Schema de forzadura",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Fresa inbevùa",
  "item.minecraft.tipped_arrow.effect.awkward": "Fresa inbevùa",
  "item.minecraft.tipped_arrow.effect.empty": "Fresa inbevùa mìa fabricàbiłe",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Fresa de rezistensa a'l fogo",
  "item.minecraft.tipped_arrow.effect.harming": "Fresa de dano",
  "item.minecraft.tipped_arrow.effect.healing": "Fresa de cura",
  "item.minecraft.tipped_arrow.effect.infested": "Fresa de infestasiòn",
  "item.minecraft.tipped_arrow.effect.invisibility": "Fresa de invizibiłidà",
  "item.minecraft.tipped_arrow.effect.leaping": "Fresa de salto",
  "item.minecraft.tipped_arrow.effect.levitation": "Fresa de łevitasion",
  "item.minecraft.tipped_arrow.effect.luck": "Fresa de fortuna",
  "item.minecraft.tipped_arrow.effect.mundane": "Fresa inbevùa",
  "item.minecraft.tipped_arrow.effect.night_vision": "Fresa de vizion noturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Fresa de secresion",
  "item.minecraft.tipped_arrow.effect.poison": "Fresa de vełen",
  "item.minecraft.tipped_arrow.effect.regeneration": "Fresa de rezenarasion",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Fresa de cascada łenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Fresa de łentesa",
  "item.minecraft.tipped_arrow.effect.strength": "Fresa de forsa",
  "item.minecraft.tipped_arrow.effect.swiftness": "Fresa de sveltesa",
  "item.minecraft.tipped_arrow.effect.thick": "Fresa inbevùa",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Fresa de'l maestro tartaruga",
  "item.minecraft.tipped_arrow.effect.water": "Fresa de'l schisetar",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Fresa de respir. acuàtega",
  "item.minecraft.tipped_arrow.effect.weakness": "Fresa de fiaca",
  "item.minecraft.tipped_arrow.effect.weaving": "Fresa de tessidura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Frecia de carga ventosa",
  "item.minecraft.tnt_minecart": "Carel co' TNT",
  "item.minecraft.torchflower_seeds": "Somensa de luxoflora",
  "item.minecraft.totem_of_undying": "Totem de l'inmortalidà",
  "item.minecraft.trader_llama_spawn_egg": "Ovo zenerador de lama del marcante",
  "item.minecraft.trial_key": "Ciave de ła sfida",
  "item.minecraft.trident": "Forca",
  "item.minecraft.tropical_fish": "Pese tropigal",
  "item.minecraft.tropical_fish_bucket": "Secio con pese tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Ovo zenerador de pesse tropigal",
  "item.minecraft.turtle_helmet": "Zgusa de tartaruga",
  "item.minecraft.turtle_scute": "Scuto de tortùga",
  "item.minecraft.turtle_spawn_egg": "Ovo zenerador de tartaruga",
  "item.minecraft.vex_armor_trim_smithing_template": "Schema de forgiatura",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ornamento d'armadura Vex",
  "item.minecraft.vex_spawn_egg": "Ovo zenerador de vex",
  "item.minecraft.villager_spawn_egg": "Ovo zenerador de paesan",
  "item.minecraft.vindicator_spawn_egg": "Ovo zenarador de vendegador",
  "item.minecraft.wandering_trader_spawn_egg": "Ovo zenarador de marcante anbułante",
  "item.minecraft.ward_armor_trim_smithing_template": "Schema de forgiatura",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ornamento d'armadura Sorvejante",
  "item.minecraft.warden_spawn_egg": "Ovo zenerador de Sorvejante",
  "item.minecraft.warped_fungus_on_a_stick": "Fongo strùpio su bachéto",
  "item.minecraft.water_bucket": "Secio de àcua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Schema de forgiatura",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ornamento d'armadura Ricognidore",
  "item.minecraft.wheat": "Formento",
  "item.minecraft.wheat_seeds": "Somensa de formento",
  "item.minecraft.white_bundle": "Sachéto bianco",
  "item.minecraft.white_dye": "Cołorante bianco",
  "item.minecraft.white_harness": "Inbragadura bianca",
  "item.minecraft.wild_armor_trim_smithing_template": "Schema de forgiatura",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ornamento d'armadura Selvàdego",
  "item.minecraft.wind_charge": "Carga de vento",
  "item.minecraft.witch_spawn_egg": "Ovo zenarador de strìa",
  "item.minecraft.wither_skeleton_spawn_egg": "Ovo zenarador de schèłetro wither",
  "item.minecraft.wither_spawn_egg": "Ovo zenerador de Wither",
  "item.minecraft.wolf_armor": "Armadura par lovo",
  "item.minecraft.wolf_spawn_egg": "Ovo zenarador de łovo",
  "item.minecraft.wooden_axe": "Manara de łenjo",
  "item.minecraft.wooden_hoe": "Sapa de łenjo",
  "item.minecraft.wooden_pickaxe": "Picon de łenjo",
  "item.minecraft.wooden_shovel": "Baìl de łenjo",
  "item.minecraft.wooden_spear": "Lança de Legno",
  "item.minecraft.wooden_sword": "Spada de łenjo",
  "item.minecraft.writable_book": "Łibro e pena",
  "item.minecraft.written_book": "Łibro scrivesto",
  "item.minecraft.yellow_bundle": "Sachéto zało",
  "item.minecraft.yellow_dye": "Cołorante zało",
  "item.minecraft.yellow_harness": "Inbragadura zalda",
  "item.minecraft.zoglin_spawn_egg": "Ovo zenerador de Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Ovo zenarador de caval zonbi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Ovo zenerador de Nautilo Zonbi",
  "item.minecraft.zombie_spawn_egg": "Ovo zenarador de zonbi",
  "item.minecraft.zombie_villager_spawn_egg": "Ovo zenerador de paesan zonbi",
  "item.minecraft.zombified_piglin_spawn_egg": "Ovo zenarador de piglin zonbifegà"
}
export const vec_it = items; 
